import type { LatLon } from "@radar-sim/schema";

/**
 * Coastline polylines derived from OpenStreetMap data via Overpass API,
 * clipped to the moray-firth bounding box and Douglas–Peucker simplified
 * at ~33 m tolerance. Re-fetch with /tmp/fetch-coastline.mjs.
 *
 * Convention:
 *   - MORAY_FIRTH_MAINLAND is an OPEN polyline along the mainland's seaward edge,
 *     clipped at the bounding-box left/right margins. Renderers close it
 *     by extending to the chart's top edge.
 *   - MORAY_FIRTH_ISLANDS are CLOSED polygons (first === last point). Includes
 *     islands and any inland water features that would draw as land.
 *
 * © OpenStreetMap contributors, ODbL.
 */

export const MORAY_FIRTH_MAINLAND: ReadonlyArray<LatLon> = [
  { lat: 57.6816, lon: -2.60011 },
  { lat: 57.6808, lon: -2.60352 },
  { lat: 57.68144, lon: -2.60525 },
  { lat: 57.68137, lon: -2.60678 },
  { lat: 57.67909, lon: -2.61294 },
  { lat: 57.67969, lon: -2.6141 },
  { lat: 57.67922, lon: -2.61582 },
  { lat: 57.67969, lon: -2.61652 },
  { lat: 57.68063, lon: -2.61529 },
  { lat: 57.68136, lon: -2.61531 },
  { lat: 57.68165, lon: -2.61608 },
  { lat: 57.68155, lon: -2.61865 },
  { lat: 57.68028, lon: -2.62002 },
  { lat: 57.68057, lon: -2.62233 },
  { lat: 57.68165, lon: -2.6226 },
  { lat: 57.68081, lon: -2.62443 },
  { lat: 57.68068, lon: -2.62889 },
  { lat: 57.68144, lon: -2.62919 },
  { lat: 57.68089, lon: -2.63096 },
  { lat: 57.68136, lon: -2.63268 },
  { lat: 57.68072, lon: -2.63408 },
  { lat: 57.68015, lon: -2.63794 },
  { lat: 57.68067, lon: -2.64008 },
  { lat: 57.6814, lon: -2.63987 },
  { lat: 57.68198, lon: -2.64062 },
  { lat: 57.68195, lon: -2.64182 },
  { lat: 57.68236, lon: -2.64184 },
  { lat: 57.68211, lon: -2.64231 },
  { lat: 57.68263, lon: -2.64212 },
  { lat: 57.68203, lon: -2.64419 },
  { lat: 57.6826, lon: -2.64589 },
  { lat: 57.6829, lon: -2.64603 },
  { lat: 57.68353, lon: -2.64434 },
  { lat: 57.68405, lon: -2.64457 },
  { lat: 57.68362, lon: -2.64575 },
  { lat: 57.68406, lon: -2.64808 },
  { lat: 57.68482, lon: -2.64839 },
  { lat: 57.6853, lon: -2.64707 },
  { lat: 57.6856, lon: -2.64792 },
  { lat: 57.68596, lon: -2.64818 },
  { lat: 57.68687, lon: -2.64765 },
  { lat: 57.68764, lon: -2.64884 },
  { lat: 57.68777, lon: -2.65027 },
  { lat: 57.68739, lon: -2.65171 },
  { lat: 57.68688, lon: -2.65171 },
  { lat: 57.68701, lon: -2.65362 },
  { lat: 57.6865, lon: -2.65458 },
  { lat: 57.68652, lon: -2.66175 },
  { lat: 57.68665, lon: -2.66223 },
  { lat: 57.68742, lon: -2.66199 },
  { lat: 57.68793, lon: -2.66102 },
  { lat: 57.68849, lon: -2.66092 },
  { lat: 57.6883, lon: -2.66142 },
  { lat: 57.68917, lon: -2.6614 },
  { lat: 57.68907, lon: -2.66485 },
  { lat: 57.6906, lon: -2.6674 },
  { lat: 57.68998, lon: -2.6691 },
  { lat: 57.68903, lon: -2.67011 },
  { lat: 57.68918, lon: -2.6712 },
  { lat: 57.68889, lon: -2.67143 },
  { lat: 57.68887, lon: -2.67104 },
  { lat: 57.68744, lon: -2.6725 },
  { lat: 57.6869, lon: -2.67461 },
  { lat: 57.68566, lon: -2.6758 },
  { lat: 57.68541, lon: -2.67658 },
  { lat: 57.68556, lon: -2.67733 },
  { lat: 57.68616, lon: -2.67759 },
  { lat: 57.6859, lon: -2.67816 },
  { lat: 57.68452, lon: -2.68068 },
  { lat: 57.68426, lon: -2.68041 },
  { lat: 57.68279, lon: -2.68177 },
  { lat: 57.68287, lon: -2.68458 },
  { lat: 57.68372, lon: -2.68671 },
  { lat: 57.68518, lon: -2.68549 },
  { lat: 57.68584, lon: -2.68598 },
  { lat: 57.68664, lon: -2.68587 },
  { lat: 57.68684, lon: -2.68668 },
  { lat: 57.68643, lon: -2.68736 },
  { lat: 57.6862, lon: -2.68707 },
  { lat: 57.68649, lon: -2.68937 },
  { lat: 57.68585, lon: -2.68955 },
  { lat: 57.68586, lon: -2.689 },
  { lat: 57.686, lon: -2.68952 },
  { lat: 57.68636, lon: -2.68918 },
  { lat: 57.68601, lon: -2.68776 },
  { lat: 57.68582, lon: -2.68879 },
  { lat: 57.68458, lon: -2.69051 },
  { lat: 57.68502, lon: -2.6907 },
  { lat: 57.68481, lon: -2.69144 },
  { lat: 57.68536, lon: -2.69098 },
  { lat: 57.68512, lon: -2.69039 },
  { lat: 57.68571, lon: -2.69081 },
  { lat: 57.68562, lon: -2.69131 },
  { lat: 57.68637, lon: -2.69121 },
  { lat: 57.68556, lon: -2.69237 },
  { lat: 57.68518, lon: -2.692 },
  { lat: 57.6854, lon: -2.69305 },
  { lat: 57.68438, lon: -2.69409 },
  { lat: 57.68485, lon: -2.69469 },
  { lat: 57.68475, lon: -2.69592 },
  { lat: 57.68536, lon: -2.6959 },
  { lat: 57.68545, lon: -2.69788 },
  { lat: 57.68599, lon: -2.69788 },
  { lat: 57.68576, lon: -2.69905 },
  { lat: 57.68678, lon: -2.69862 },
  { lat: 57.68597, lon: -2.70019 },
  { lat: 57.686, lon: -2.70189 },
  { lat: 57.68557, lon: -2.70222 },
  { lat: 57.68578, lon: -2.70305 },
  { lat: 57.68678, lon: -2.7031 },
  { lat: 57.68624, lon: -2.70451 },
  { lat: 57.687, lon: -2.70418 },
  { lat: 57.68653, lon: -2.70436 },
  { lat: 57.68686, lon: -2.70481 },
  { lat: 57.68591, lon: -2.70592 },
  { lat: 57.68601, lon: -2.70667 },
  { lat: 57.68741, lon: -2.70672 },
  { lat: 57.68716, lon: -2.70809 },
  { lat: 57.68866, lon: -2.70838 },
  { lat: 57.68826, lon: -2.70958 },
  { lat: 57.6885, lon: -2.70908 },
  { lat: 57.68897, lon: -2.7096 },
  { lat: 57.68851, lon: -2.71043 },
  { lat: 57.68966, lon: -2.70943 },
  { lat: 57.68882, lon: -2.71053 },
  { lat: 57.68969, lon: -2.70981 },
  { lat: 57.68993, lon: -2.71047 },
  { lat: 57.69023, lon: -2.7102 },
  { lat: 57.6906, lon: -2.71295 },
  { lat: 57.69128, lon: -2.71353 },
  { lat: 57.69124, lon: -2.71302 },
  { lat: 57.69158, lon: -2.71322 },
  { lat: 57.69164, lon: -2.71394 },
  { lat: 57.69207, lon: -2.71324 },
  { lat: 57.69268, lon: -2.71429 },
  { lat: 57.69182, lon: -2.71455 },
  { lat: 57.69245, lon: -2.71501 },
  { lat: 57.69236, lon: -2.71547 },
  { lat: 57.69168, lon: -2.71558 },
  { lat: 57.69228, lon: -2.71595 },
  { lat: 57.69224, lon: -2.71642 },
  { lat: 57.69184, lon: -2.7164 },
  { lat: 57.6923, lon: -2.71675 },
  { lat: 57.6913, lon: -2.71684 },
  { lat: 57.69164, lon: -2.71757 },
  { lat: 57.69197, lon: -2.71744 },
  { lat: 57.69185, lon: -2.71786 },
  { lat: 57.69111, lon: -2.71792 },
  { lat: 57.69092, lon: -2.71897 },
  { lat: 57.69027, lon: -2.71914 },
  { lat: 57.69066, lon: -2.71942 },
  { lat: 57.68937, lon: -2.72005 },
  { lat: 57.6899, lon: -2.72037 },
  { lat: 57.68889, lon: -2.72145 },
  { lat: 57.68898, lon: -2.7221 },
  { lat: 57.68943, lon: -2.72181 },
  { lat: 57.6894, lon: -2.7234 },
  { lat: 57.68886, lon: -2.7247 },
  { lat: 57.68845, lon: -2.72417 },
  { lat: 57.68781, lon: -2.72441 },
  { lat: 57.68785, lon: -2.72604 },
  { lat: 57.68745, lon: -2.72571 },
  { lat: 57.68751, lon: -2.7266 },
  { lat: 57.68709, lon: -2.72658 },
  { lat: 57.6868, lon: -2.72742 },
  { lat: 57.68698, lon: -2.72852 },
  { lat: 57.68631, lon: -2.72976 },
  { lat: 57.68617, lon: -2.73194 },
  { lat: 57.68524, lon: -2.73147 },
  { lat: 57.68426, lon: -2.73204 },
  { lat: 57.68404, lon: -2.73477 },
  { lat: 57.68414, lon: -2.73549 },
  { lat: 57.68459, lon: -2.73537 },
  { lat: 57.68453, lon: -2.73608 },
  { lat: 57.68349, lon: -2.73575 },
  { lat: 57.68305, lon: -2.73616 },
  { lat: 57.68184, lon: -2.73863 },
  { lat: 57.68175, lon: -2.7402 },
  { lat: 57.68285, lon: -2.74604 },
  { lat: 57.68249, lon: -2.74757 },
  { lat: 57.68342, lon: -2.74811 },
  { lat: 57.68458, lon: -2.74789 },
  { lat: 57.68695, lon: -2.74618 },
  { lat: 57.68605, lon: -2.74678 },
  { lat: 57.68639, lon: -2.74673 },
  { lat: 57.6861, lon: -2.74708 },
  { lat: 57.68648, lon: -2.74701 },
  { lat: 57.68619, lon: -2.74746 },
  { lat: 57.68654, lon: -2.74779 },
  { lat: 57.6866, lon: -2.74693 },
  { lat: 57.6871, lon: -2.74829 },
  { lat: 57.68941, lon: -2.74777 },
  { lat: 57.68967, lon: -2.7492 },
  { lat: 57.69095, lon: -2.7492 },
  { lat: 57.69095, lon: -2.75015 },
  { lat: 57.69147, lon: -2.75015 },
  { lat: 57.69128, lon: -2.75154 },
  { lat: 57.6907, lon: -2.75207 },
  { lat: 57.69071, lon: -2.75279 },
  { lat: 57.69033, lon: -2.75277 },
  { lat: 57.69074, lon: -2.75369 },
  { lat: 57.69122, lon: -2.7535 },
  { lat: 57.69044, lon: -2.75625 },
  { lat: 57.69057, lon: -2.7567 },
  { lat: 57.69128, lon: -2.75654 },
  { lat: 57.69097, lon: -2.7578 },
  { lat: 57.69199, lon: -2.75684 },
  { lat: 57.69174, lon: -2.75827 },
  { lat: 57.69404, lon: -2.75778 },
  { lat: 57.69379, lon: -2.76017 },
  { lat: 57.69302, lon: -2.76018 },
  { lat: 57.69277, lon: -2.76448 },
  { lat: 57.69226, lon: -2.76448 },
  { lat: 57.6929, lon: -2.76591 },
  { lat: 57.6924, lon: -2.76926 },
  { lat: 57.69307, lon: -2.77058 },
  { lat: 57.69236, lon: -2.77061 },
  { lat: 57.69217, lon: -2.77119 },
  { lat: 57.69252, lon: -2.77274 },
  { lat: 57.6929, lon: -2.77258 },
  { lat: 57.69343, lon: -2.77316 },
  { lat: 57.69319, lon: -2.77458 },
  { lat: 57.69381, lon: -2.77446 },
  { lat: 57.69254, lon: -2.77739 },
  { lat: 57.69383, lon: -2.78025 },
  { lat: 57.6951, lon: -2.78544 },
  { lat: 57.6964, lon: -2.78621 },
  { lat: 57.69691, lon: -2.78597 },
  { lat: 57.69691, lon: -2.78884 },
  { lat: 57.6987, lon: -2.78907 },
  { lat: 57.70024, lon: -2.78834 },
  { lat: 57.6996, lon: -2.79121 },
  { lat: 57.69999, lon: -2.79265 },
  { lat: 57.70076, lon: -2.79264 },
  { lat: 57.70076, lon: -2.79312 },
  { lat: 57.69999, lon: -2.79343 },
  { lat: 57.70025, lon: -2.79452 },
  { lat: 57.69974, lon: -2.79552 },
  { lat: 57.69642, lon: -2.7984 },
  { lat: 57.69642, lon: -2.79936 },
  { lat: 57.69591, lon: -2.79936 },
  { lat: 57.69527, lon: -2.80176 },
  { lat: 57.69527, lon: -2.80319 },
  { lat: 57.69617, lon: -2.80558 },
  { lat: 57.6972, lon: -2.80605 },
  { lat: 57.69594, lon: -2.8096 },
  { lat: 57.69597, lon: -2.81355 },
  { lat: 57.69452, lon: -2.81682 },
  { lat: 57.69433, lon: -2.82396 },
  { lat: 57.69385, lon: -2.82248 },
  { lat: 57.69372, lon: -2.82335 },
  { lat: 57.69346, lon: -2.8223 },
  { lat: 57.69273, lon: -2.82301 },
  { lat: 57.69297, lon: -2.82391 },
  { lat: 57.694, lon: -2.82365 },
  { lat: 57.69265, lon: -2.82387 },
  { lat: 57.69257, lon: -2.82713 },
  { lat: 57.69523, lon: -2.83859 },
  { lat: 57.69832, lon: -2.84628 },
  { lat: 57.69909, lon: -2.84691 },
  { lat: 57.70051, lon: -2.84681 },
  { lat: 57.70138, lon: -2.8476 },
  { lat: 57.70196, lon: -2.84735 },
  { lat: 57.70191, lon: -2.84663 },
  { lat: 57.70214, lon: -2.84751 },
  { lat: 57.70326, lon: -2.84769 },
  { lat: 57.70392, lon: -2.84607 },
  { lat: 57.70389, lon: -2.84647 },
  { lat: 57.70468, lon: -2.8464 },
  { lat: 57.70472, lon: -2.847 },
  { lat: 57.70507, lon: -2.84653 },
  { lat: 57.70479, lon: -2.84758 },
  { lat: 57.70529, lon: -2.84705 },
  { lat: 57.70551, lon: -2.84889 },
  { lat: 57.70611, lon: -2.84783 },
  { lat: 57.70564, lon: -2.85249 },
  { lat: 57.70618, lon: -2.85241 },
  { lat: 57.70614, lon: -2.85346 },
  { lat: 57.70564, lon: -2.85517 },
  { lat: 57.70619, lon: -2.85617 },
  { lat: 57.70579, lon: -2.8567 },
  { lat: 57.70531, lon: -2.85642 },
  { lat: 57.70507, lon: -2.85753 },
  { lat: 57.70534, lon: -2.85851 },
  { lat: 57.70581, lon: -2.85834 },
  { lat: 57.70551, lon: -2.85915 },
  { lat: 57.70628, lon: -2.85798 },
  { lat: 57.70628, lon: -2.85894 },
  { lat: 57.70653, lon: -2.85866 },
  { lat: 57.70627, lon: -2.85982 },
  { lat: 57.70542, lon: -2.86058 },
  { lat: 57.70566, lon: -2.86126 },
  { lat: 57.70587, lon: -2.86068 },
  { lat: 57.70586, lon: -2.8614 },
  { lat: 57.70604, lon: -2.86093 },
  { lat: 57.70553, lon: -2.86268 },
  { lat: 57.70525, lon: -2.86253 },
  { lat: 57.70518, lon: -2.86415 },
  { lat: 57.70484, lon: -2.86345 },
  { lat: 57.70507, lon: -2.86138 },
  { lat: 57.70437, lon: -2.86103 },
  { lat: 57.70397, lon: -2.86214 },
  { lat: 57.70489, lon: -2.86239 },
  { lat: 57.70403, lon: -2.86237 },
  { lat: 57.704, lon: -2.86326 },
  { lat: 57.70471, lon: -2.86354 },
  { lat: 57.70399, lon: -2.86356 },
  { lat: 57.70346, lon: -2.86522 },
  { lat: 57.70388, lon: -2.86701 },
  { lat: 57.70336, lon: -2.86716 },
  { lat: 57.70321, lon: -2.86951 },
  { lat: 57.70364, lon: -2.87029 },
  { lat: 57.70429, lon: -2.87008 },
  { lat: 57.70351, lon: -2.87113 },
  { lat: 57.7038, lon: -2.87243 },
  { lat: 57.70336, lon: -2.87315 },
  { lat: 57.7041, lon: -2.87441 },
  { lat: 57.70464, lon: -2.87369 },
  { lat: 57.70417, lon: -2.87501 },
  { lat: 57.70433, lon: -2.87533 },
  { lat: 57.70461, lon: -2.8749 },
  { lat: 57.7046, lon: -2.87561 },
  { lat: 57.70511, lon: -2.87459 },
  { lat: 57.70497, lon: -2.8787 },
  { lat: 57.70445, lon: -2.8787 },
  { lat: 57.70445, lon: -2.87918 },
  { lat: 57.70497, lon: -2.87918 },
  { lat: 57.70471, lon: -2.88014 },
  { lat: 57.7042, lon: -2.87942 },
  { lat: 57.70361, lon: -2.87962 },
  { lat: 57.7024, lon: -2.88178 },
  { lat: 57.70259, lon: -2.88367 },
  { lat: 57.70233, lon: -2.88324 },
  { lat: 57.70211, lon: -2.88356 },
  { lat: 57.7019, lon: -2.88636 },
  { lat: 57.70156, lon: -2.88605 },
  { lat: 57.70126, lon: -2.88684 },
  { lat: 57.70139, lon: -2.88732 },
  { lat: 57.7019, lon: -2.88732 },
  { lat: 57.70165, lon: -2.88923 },
  { lat: 57.70082, lon: -2.8899 },
  { lat: 57.70104, lon: -2.89043 },
  { lat: 57.70047, lon: -2.89117 },
  { lat: 57.69967, lon: -2.8956 },
  { lat: 57.70045, lon: -2.89822 },
  { lat: 57.70105, lon: -2.8982 },
  { lat: 57.70123, lon: -2.89716 },
  { lat: 57.70182, lon: -2.89742 },
  { lat: 57.70111, lon: -2.90021 },
  { lat: 57.70153, lon: -2.90127 },
  { lat: 57.70097, lon: -2.90253 },
  { lat: 57.70101, lon: -2.90116 },
  { lat: 57.70091, lon: -2.90158 },
  { lat: 57.7006, lon: -2.90133 },
  { lat: 57.70073, lon: -2.90275 },
  { lat: 57.70046, lon: -2.90337 },
  { lat: 57.70027, lon: -2.90241 },
  { lat: 57.70015, lon: -2.90427 },
  { lat: 57.69983, lon: -2.90318 },
  { lat: 57.69946, lon: -2.90362 },
  { lat: 57.699, lon: -2.90315 },
  { lat: 57.69888, lon: -2.9039 },
  { lat: 57.69879, lon: -2.9029 },
  { lat: 57.69827, lon: -2.90338 },
  { lat: 57.69847, lon: -2.90441 },
  { lat: 57.6982, lon: -2.9034 },
  { lat: 57.6977, lon: -2.90395 },
  { lat: 57.69751, lon: -2.90553 },
  { lat: 57.69798, lon: -2.9065 },
  { lat: 57.69895, lon: -2.90423 },
  { lat: 57.69826, lon: -2.90632 },
  { lat: 57.69867, lon: -2.90804 },
  { lat: 57.69842, lon: -2.90983 },
  { lat: 57.69912, lon: -2.91069 },
  { lat: 57.69863, lon: -2.91112 },
  { lat: 57.6987, lon: -2.91356 },
  { lat: 57.6982, lon: -2.91362 },
  { lat: 57.69833, lon: -2.91455 },
  { lat: 57.69863, lon: -2.91405 },
  { lat: 57.69843, lon: -2.91503 },
  { lat: 57.69685, lon: -2.9173 },
  { lat: 57.69704, lon: -2.91949 },
  { lat: 57.69783, lon: -2.91984 },
  { lat: 57.69746, lon: -2.92227 },
  { lat: 57.69741, lon: -2.92191 },
  { lat: 57.69683, lon: -2.9223 },
  { lat: 57.69689, lon: -2.92305 },
  { lat: 57.69634, lon: -2.9236 },
  { lat: 57.69612, lon: -2.92331 },
  { lat: 57.69554, lon: -2.92487 },
  { lat: 57.69524, lon: -2.92506 },
  { lat: 57.69514, lon: -2.92466 },
  { lat: 57.69462, lon: -2.92523 },
  { lat: 57.69338, lon: -2.92791 },
  { lat: 57.69289, lon: -2.92764 },
  { lat: 57.69226, lon: -2.92853 },
  { lat: 57.69154, lon: -2.92735 },
  { lat: 57.69091, lon: -2.92717 },
  { lat: 57.6894, lon: -2.92838 },
  { lat: 57.687, lon: -2.93184 },
  { lat: 57.68594, lon: -2.93663 },
  { lat: 57.68612, lon: -2.9397 },
  { lat: 57.6857, lon: -2.94123 },
  { lat: 57.68525, lon: -2.94088 },
  { lat: 57.6848, lon: -2.94164 },
  { lat: 57.68497, lon: -2.94318 },
  { lat: 57.68371, lon: -2.94717 },
  { lat: 57.68418, lon: -2.95002 },
  { lat: 57.68383, lon: -2.9513 },
  { lat: 57.68238, lon: -2.95193 },
  { lat: 57.68046, lon: -2.9591 },
  { lat: 57.68063, lon: -2.96188 },
  { lat: 57.68023, lon: -2.95945 },
  { lat: 57.68228, lon: -2.95179 },
  { lat: 57.6813, lon: -2.95153 },
  { lat: 57.68089, lon: -2.95232 },
  { lat: 57.68054, lon: -2.95415 },
  { lat: 57.6813, lon: -2.95489 },
  { lat: 57.68049, lon: -2.95432 },
  { lat: 57.68017, lon: -2.95551 },
  { lat: 57.68089, lon: -2.95622 },
  { lat: 57.68011, lon: -2.95572 },
  { lat: 57.67982, lon: -2.95682 },
  { lat: 57.68053, lon: -2.95758 },
  { lat: 57.67981, lon: -2.95709 },
  { lat: 57.67918, lon: -2.95943 },
  { lat: 57.68004, lon: -2.95933 },
  { lat: 57.67959, lon: -2.96072 },
  { lat: 57.68001, lon: -2.96069 },
  { lat: 57.67997, lon: -2.96005 },
  { lat: 57.68018, lon: -2.96074 },
  { lat: 57.67887, lon: -2.96168 },
  { lat: 57.67858, lon: -2.96303 },
  { lat: 57.67841, lon: -2.96696 },
  { lat: 57.67915, lon: -2.96918 },
  { lat: 57.67832, lon: -2.97341 },
  { lat: 57.67702, lon: -2.97516 },
  { lat: 57.67733, lon: -2.97592 },
  { lat: 57.67699, lon: -2.97586 },
  { lat: 57.67703, lon: -2.97647 },
  { lat: 57.67731, lon: -2.97629 },
  { lat: 57.67703, lon: -2.97805 },
  { lat: 57.67402, lon: -2.98564 },
  { lat: 57.67232, lon: -2.99472 },
  { lat: 57.66872, lon: -2.99924 },
  { lat: 57.66661, lon: -3.00427 },
  { lat: 57.66596, lon: -3.00793 },
  { lat: 57.66616, lon: -3.01378 },
  { lat: 57.66552, lon: -3.01364 },
  { lat: 57.665, lon: -3.0157 },
  { lat: 57.66435, lon: -3.01561 },
  { lat: 57.66416, lon: -3.01613 },
  { lat: 57.66359, lon: -3.02714 },
  { lat: 57.66485, lon: -3.03903 },
  { lat: 57.66697, lon: -3.04959 },
  { lat: 57.6715, lon: -3.078 },
  { lat: 57.67603, lon: -3.09933 },
  { lat: 57.6755, lon: -3.1003 },
  { lat: 57.67435, lon: -3.09565 },
  { lat: 57.67397, lon: -3.09581 },
  { lat: 57.67177, lon: -3.09259 },
  { lat: 57.67097, lon: -3.09258 },
  { lat: 57.669, lon: -3.09532 },
  { lat: 57.66702, lon: -3.09323 },
  { lat: 57.66619, lon: -3.09314 },
  { lat: 57.66353, lon: -3.09552 },
  { lat: 57.66306, lon: -3.09763 },
  { lat: 57.66476, lon: -3.09991 },
  { lat: 57.6666, lon: -3.09936 },
  { lat: 57.66761, lon: -3.09957 },
  { lat: 57.66972, lon: -3.098 },
  { lat: 57.67049, lon: -3.0947 },
  { lat: 57.67181, lon: -3.0944 },
  { lat: 57.67258, lon: -3.095 },
  { lat: 57.67298, lon: -3.09577 },
  { lat: 57.67076, lon: -3.09579 },
  { lat: 57.67164, lon: -3.09641 },
  { lat: 57.67086, lon: -3.09648 },
  { lat: 57.67022, lon: -3.09745 },
  { lat: 57.67134, lon: -3.09964 },
  { lat: 57.67318, lon: -3.10073 },
  { lat: 57.67293, lon: -3.10315 },
  { lat: 57.67145, lon: -3.10408 },
  { lat: 57.67102, lon: -3.10508 },
  { lat: 57.66845, lon: -3.10536 },
  { lat: 57.67074, lon: -3.10553 },
  { lat: 57.67003, lon: -3.10587 },
  { lat: 57.67052, lon: -3.10595 },
  { lat: 57.6733, lon: -3.10424 },
  { lat: 57.67395, lon: -3.10513 },
  { lat: 57.67357, lon: -3.1058 },
  { lat: 57.67402, lon: -3.10673 },
  { lat: 57.67312, lon: -3.10809 },
  { lat: 57.67242, lon: -3.10771 },
  { lat: 57.67314, lon: -3.1083 },
  { lat: 57.67413, lon: -3.107 },
  { lat: 57.67484, lon: -3.10691 },
  { lat: 57.67592, lon: -3.11387 },
  { lat: 57.67523, lon: -3.10529 },
  { lat: 57.67491, lon: -3.10666 },
  { lat: 57.67427, lon: -3.10597 },
  { lat: 57.67464, lon: -3.10571 },
  { lat: 57.67436, lon: -3.10421 },
  { lat: 57.67526, lon: -3.10439 },
  { lat: 57.67537, lon: -3.10347 },
  { lat: 57.67472, lon: -3.10323 },
  { lat: 57.67428, lon: -3.10193 },
  { lat: 57.67408, lon: -3.09966 },
  { lat: 57.67503, lon: -3.10262 },
  { lat: 57.67586, lon: -3.1029 },
  { lat: 57.67668, lon: -3.1041 },
  { lat: 57.67577, lon: -3.10957 },
  { lat: 57.67611, lon: -3.11312 },
  { lat: 57.68025, lon: -3.13685 },
  { lat: 57.68635, lon: -3.16699 },
  { lat: 57.69348, lon: -3.19427 },
  { lat: 57.6945, lon: -3.20049 },
  { lat: 57.70155, lon: -3.23059 },
  { lat: 57.71181, lon: -3.26222 },
  { lat: 57.71841, lon: -3.27855 },
  { lat: 57.71892, lon: -3.27943 },
  { lat: 57.71961, lon: -3.27916 },
  { lat: 57.71921, lon: -3.27954 },
  { lat: 57.71923, lon: -3.28077 },
  { lat: 57.71834, lon: -3.2816 },
  { lat: 57.71766, lon: -3.27953 },
  { lat: 57.71718, lon: -3.27965 },
  { lat: 57.71682, lon: -3.27678 },
  { lat: 57.71601, lon: -3.2773 },
  { lat: 57.71484, lon: -3.27582 },
  { lat: 57.71507, lon: -3.27498 },
  { lat: 57.71336, lon: -3.27227 },
  { lat: 57.71096, lon: -3.26646 },
  { lat: 57.71025, lon: -3.26589 },
  { lat: 57.70928, lon: -3.26655 },
  { lat: 57.70876, lon: -3.26589 },
  { lat: 57.70556, lon: -3.25589 },
  { lat: 57.70356, lon: -3.25396 },
  { lat: 57.70367, lon: -3.25493 },
  { lat: 57.70561, lon: -3.25819 },
  { lat: 57.70727, lon: -3.26527 },
  { lat: 57.71491, lon: -3.27992 },
  { lat: 57.71671, lon: -3.28045 },
  { lat: 57.71743, lon: -3.28258 },
  { lat: 57.71824, lon: -3.28297 },
  { lat: 57.71897, lon: -3.28252 },
  { lat: 57.72015, lon: -3.27948 },
  { lat: 57.72189, lon: -3.27901 },
  { lat: 57.72368, lon: -3.27784 },
  { lat: 57.72393, lon: -3.27905 },
  { lat: 57.72371, lon: -3.27854 },
  { lat: 57.72329, lon: -3.27873 },
  { lat: 57.72206, lon: -3.27943 },
  { lat: 57.72212, lon: -3.27993 },
  { lat: 57.72375, lon: -3.27915 },
  { lat: 57.72432, lon: -3.28379 },
  { lat: 57.72473, lon: -3.28341 },
  { lat: 57.72401, lon: -3.27976 },
  { lat: 57.72451, lon: -3.28023 },
  { lat: 57.72375, lon: -3.27724 },
  { lat: 57.72445, lon: -3.27877 },
  { lat: 57.72497, lon: -3.28367 },
  { lat: 57.7245, lon: -3.2846 },
  { lat: 57.72517, lon: -3.28935 },
  { lat: 57.72454, lon: -3.29315 },
  { lat: 57.72312, lon: -3.29481 },
  { lat: 57.72291, lon: -3.29578 },
  { lat: 57.72233, lon: -3.29571 },
  { lat: 57.72184, lon: -3.29657 },
  { lat: 57.72052, lon: -3.30422 },
  { lat: 57.72128, lon: -3.31539 },
  { lat: 57.72447, lon: -3.32895 },
  { lat: 57.72498, lon: -3.33853 },
  { lat: 57.72454, lon: -3.3455 },
  { lat: 57.72212, lon: -3.35865 },
  { lat: 57.72175, lon: -3.36258 },
  { lat: 57.72216, lon: -3.36358 },
  { lat: 57.72117, lon: -3.36658 },
  { lat: 57.72074, lon: -3.37334 },
  { lat: 57.71972, lon: -3.37613 },
  { lat: 57.71945, lon: -3.38493 },
  { lat: 57.71621, lon: -3.39179 },
  { lat: 57.71582, lon: -3.39766 },
  { lat: 57.7165, lon: -3.39854 },
  { lat: 57.71561, lon: -3.40185 },
  { lat: 57.71469, lon: -3.40194 },
  { lat: 57.71559, lon: -3.40301 },
  { lat: 57.71486, lon: -3.40757 },
  { lat: 57.71459, lon: -3.40773 },
  { lat: 57.71472, lon: -3.40725 },
  { lat: 57.71427, lon: -3.40754 },
  { lat: 57.71388, lon: -3.40842 },
  { lat: 57.71349, lon: -3.41149 },
  { lat: 57.71286, lon: -3.4125 },
  { lat: 57.71294, lon: -3.4134 },
  { lat: 57.7135, lon: -3.41376 },
  { lat: 57.71401, lon: -3.41695 },
  { lat: 57.71508, lon: -3.41914 },
  { lat: 57.7128, lon: -3.42271 },
  { lat: 57.71316, lon: -3.42445 },
  { lat: 57.71285, lon: -3.42491 },
  { lat: 57.71328, lon: -3.42534 },
  { lat: 57.71194, lon: -3.42533 },
  { lat: 57.7108, lon: -3.42795 },
  { lat: 57.71091, lon: -3.43087 },
  { lat: 57.71028, lon: -3.43213 },
  { lat: 57.7103, lon: -3.43399 },
  { lat: 57.71065, lon: -3.43529 },
  { lat: 57.71147, lon: -3.43545 },
  { lat: 57.71204, lon: -3.43644 },
  { lat: 57.71189, lon: -3.43846 },
  { lat: 57.71194, lon: -3.43652 },
  { lat: 57.71101, lon: -3.43565 },
  { lat: 57.71096, lon: -3.43652 },
  { lat: 57.71148, lon: -3.43696 },
  { lat: 57.71036, lon: -3.43663 },
  { lat: 57.71029, lon: -3.43728 },
  { lat: 57.7115, lon: -3.43799 },
  { lat: 57.71176, lon: -3.43692 },
  { lat: 57.71165, lon: -3.43818 },
  { lat: 57.71, lon: -3.43745 },
  { lat: 57.70942, lon: -3.43838 },
  { lat: 57.70903, lon: -3.44065 },
  { lat: 57.70924, lon: -3.44337 },
  { lat: 57.70785, lon: -3.4469 },
  { lat: 57.70756, lon: -3.44667 },
  { lat: 57.70704, lon: -3.44773 },
  { lat: 57.70654, lon: -3.4516 },
  { lat: 57.70524, lon: -3.45306 },
  { lat: 57.70432, lon: -3.45546 },
  { lat: 57.70492, lon: -3.45738 },
  { lat: 57.70393, lon: -3.45815 },
  { lat: 57.70349, lon: -3.47109 },
  { lat: 57.70377, lon: -3.47484 },
  { lat: 57.70217, lon: -3.48229 },
  { lat: 57.70324, lon: -3.48962 },
  { lat: 57.70395, lon: -3.49118 },
  { lat: 57.70439, lon: -3.4978 },
  { lat: 57.70212, lon: -3.49936 },
  { lat: 57.70132, lon: -3.50047 },
  { lat: 57.70285, lon: -3.49835 },
  { lat: 57.70169, lon: -3.49529 },
  { lat: 57.70226, lon: -3.49849 },
  { lat: 57.70189, lon: -3.49893 },
  { lat: 57.70085, lon: -3.49498 },
  { lat: 57.70118, lon: -3.4946 },
  { lat: 57.7007, lon: -3.49252 },
  { lat: 57.69969, lon: -3.48969 },
  { lat: 57.69587, lon: -3.48895 },
  { lat: 57.69238, lon: -3.4896 },
  { lat: 57.6844, lon: -3.49312 },
  { lat: 57.67909, lon: -3.4967 },
  { lat: 57.67487, lon: -3.50213 },
  { lat: 57.67046, lon: -3.50948 },
  { lat: 57.66742, lon: -3.51746 },
  { lat: 57.66451, lon: -3.52783 },
  { lat: 57.66226, lon: -3.54233 },
  { lat: 57.66143, lon: -3.55665 },
  { lat: 57.66183, lon: -3.58101 },
  { lat: 57.66398, lon: -3.61401 },
  { lat: 57.66401, lon: -3.61931 },
  { lat: 57.66315, lon: -3.62369 },
  { lat: 57.66218, lon: -3.6258 },
  { lat: 57.66148, lon: -3.62656 },
  { lat: 57.66115, lon: -3.62625 },
  { lat: 57.66166, lon: -3.62386 },
  { lat: 57.66265, lon: -3.62307 },
  { lat: 57.66278, lon: -3.62122 },
  { lat: 57.65855, lon: -3.61087 },
  { lat: 57.65495, lon: -3.60481 },
  { lat: 57.65099, lon: -3.60016 },
  { lat: 57.65166, lon: -3.59858 },
  { lat: 57.65147, lon: -3.59505 },
  { lat: 57.64905, lon: -3.59007 },
  { lat: 57.64904, lon: -3.58891 },
  { lat: 57.64882, lon: -3.58934 },
  { lat: 57.64768, lon: -3.58706 },
  { lat: 57.64734, lon: -3.58722 },
  { lat: 57.64693, lon: -3.5857 },
  { lat: 57.64565, lon: -3.58476 },
  { lat: 57.64533, lon: -3.58525 },
  { lat: 57.64604, lon: -3.58293 },
  { lat: 57.64529, lon: -3.58501 },
  { lat: 57.64453, lon: -3.58446 },
  { lat: 57.64425, lon: -3.58332 },
  { lat: 57.64403, lon: -3.58389 },
  { lat: 57.64359, lon: -3.58323 },
  { lat: 57.64321, lon: -3.58375 },
  { lat: 57.64258, lon: -3.58305 },
  { lat: 57.64192, lon: -3.58467 },
  { lat: 57.64143, lon: -3.58368 },
  { lat: 57.641, lon: -3.5838 },
  { lat: 57.64081, lon: -3.58287 },
  { lat: 57.63997, lon: -3.58285 },
  { lat: 57.63935, lon: -3.58166 },
  { lat: 57.63877, lon: -3.58198 },
  { lat: 57.63824, lon: -3.58126 },
  { lat: 57.6384, lon: -3.58042 },
  { lat: 57.63747, lon: -3.58204 },
  { lat: 57.63705, lon: -3.58139 },
  { lat: 57.63689, lon: -3.58201 },
  { lat: 57.63645, lon: -3.58014 },
  { lat: 57.63673, lon: -3.58204 },
  { lat: 57.63491, lon: -3.58238 },
  { lat: 57.6345, lon: -3.58137 },
  { lat: 57.63468, lon: -3.5831 },
  { lat: 57.63396, lon: -3.5862 },
  { lat: 57.63334, lon: -3.58645 },
  { lat: 57.63307, lon: -3.58728 },
  { lat: 57.63276, lon: -3.58714 },
  { lat: 57.63223, lon: -3.58937 },
  { lat: 57.6312, lon: -3.58959 },
  { lat: 57.63172, lon: -3.5931 },
  { lat: 57.63107, lon: -3.59613 },
  { lat: 57.63172, lon: -3.59513 },
  { lat: 57.63274, lon: -3.59552 },
  { lat: 57.63375, lon: -3.59711 },
  { lat: 57.63406, lon: -3.59896 },
  { lat: 57.63408, lon: -3.60034 },
  { lat: 57.63349, lon: -3.60076 },
  { lat: 57.63148, lon: -3.60065 },
  { lat: 57.63392, lon: -3.60126 },
  { lat: 57.63388, lon: -3.60224 },
  { lat: 57.6345, lon: -3.60233 },
  { lat: 57.63407, lon: -3.6029 },
  { lat: 57.63438, lon: -3.60322 },
  { lat: 57.6339, lon: -3.6048 },
  { lat: 57.63405, lon: -3.60616 },
  { lat: 57.63456, lon: -3.6058 },
  { lat: 57.63425, lon: -3.60663 },
  { lat: 57.63461, lon: -3.60618 },
  { lat: 57.63464, lon: -3.60681 },
  { lat: 57.63505, lon: -3.60627 },
  { lat: 57.63568, lon: -3.60725 },
  { lat: 57.63527, lon: -3.60837 },
  { lat: 57.6359, lon: -3.60814 },
  { lat: 57.63481, lon: -3.60899 },
  { lat: 57.63516, lon: -3.60908 },
  { lat: 57.63494, lon: -3.61027 },
  { lat: 57.63531, lon: -3.60991 },
  { lat: 57.63616, lon: -3.61121 },
  { lat: 57.63622, lon: -3.61223 },
  { lat: 57.63598, lon: -3.61172 },
  { lat: 57.63563, lon: -3.61202 },
  { lat: 57.63597, lon: -3.61193 },
  { lat: 57.63633, lon: -3.613 },
  { lat: 57.63622, lon: -3.61425 },
  { lat: 57.63545, lon: -3.61385 },
  { lat: 57.63569, lon: -3.61476 },
  { lat: 57.63438, lon: -3.61554 },
  { lat: 57.63447, lon: -3.61606 },
  { lat: 57.6352, lon: -3.61548 },
  { lat: 57.635, lon: -3.61749 },
  { lat: 57.6357, lon: -3.61965 },
  { lat: 57.63494, lon: -3.62129 },
  { lat: 57.63598, lon: -3.62047 },
  { lat: 57.63745, lon: -3.62144 },
  { lat: 57.63822, lon: -3.62097 },
  { lat: 57.63811, lon: -3.62333 },
  { lat: 57.6381, lon: -3.62234 },
  { lat: 57.63895, lon: -3.62156 },
  { lat: 57.63867, lon: -3.62299 },
  { lat: 57.63585, lon: -3.62642 },
  { lat: 57.63467, lon: -3.62878 },
  { lat: 57.63885, lon: -3.62494 },
  { lat: 57.63945, lon: -3.62501 },
  { lat: 57.63815, lon: -3.6268 },
  { lat: 57.63898, lon: -3.62548 },
  { lat: 57.63968, lon: -3.62543 },
  { lat: 57.63888, lon: -3.62644 },
  { lat: 57.63932, lon: -3.62741 },
  { lat: 57.63985, lon: -3.62755 },
  { lat: 57.63818, lon: -3.62902 },
  { lat: 57.63686, lon: -3.63113 },
  { lat: 57.63562, lon: -3.63512 },
  { lat: 57.63567, lon: -3.63625 },
  { lat: 57.635, lon: -3.63698 },
  { lat: 57.63574, lon: -3.63671 },
  { lat: 57.63596, lon: -3.63512 },
  { lat: 57.63665, lon: -3.6359 },
  { lat: 57.63642, lon: -3.63518 },
  { lat: 57.63748, lon: -3.63244 },
  { lat: 57.63921, lon: -3.63061 },
  { lat: 57.63932, lon: -3.63186 },
  { lat: 57.63861, lon: -3.63266 },
  { lat: 57.63862, lon: -3.63204 },
  { lat: 57.63836, lon: -3.6334 },
  { lat: 57.63892, lon: -3.63239 },
  { lat: 57.63995, lon: -3.63246 },
  { lat: 57.64072, lon: -3.63319 },
  { lat: 57.64081, lon: -3.63552 },
  { lat: 57.64015, lon: -3.63612 },
  { lat: 57.63996, lon: -3.63739 },
  { lat: 57.64098, lon: -3.63651 },
  { lat: 57.64029, lon: -3.6378 },
  { lat: 57.64099, lon: -3.63686 },
  { lat: 57.64102, lon: -3.63829 },
  { lat: 57.64173, lon: -3.63512 },
  { lat: 57.64326, lon: -3.6361 },
  { lat: 57.64337, lon: -3.63992 },
  { lat: 57.64247, lon: -3.64158 },
  { lat: 57.64194, lon: -3.64183 },
  { lat: 57.64111, lon: -3.6382 },
  { lat: 57.64114, lon: -3.63976 },
  { lat: 57.64066, lon: -3.64056 },
  { lat: 57.64123, lon: -3.63973 },
  { lat: 57.64123, lon: -3.64263 },
  { lat: 57.63956, lon: -3.64549 },
  { lat: 57.64014, lon: -3.64501 },
  { lat: 57.64008, lon: -3.64584 },
  { lat: 57.6404, lon: -3.64508 },
  { lat: 57.64015, lon: -3.64596 },
  { lat: 57.63828, lon: -3.64483 },
  { lat: 57.63652, lon: -3.64535 },
  { lat: 57.6385, lon: -3.64528 },
  { lat: 57.63915, lon: -3.64597 },
  { lat: 57.63932, lon: -3.64629 },
  { lat: 57.63872, lon: -3.64631 },
  { lat: 57.63818, lon: -3.6459 },
  { lat: 57.63827, lon: -3.64744 },
  { lat: 57.63834, lon: -3.64626 },
  { lat: 57.63917, lon: -3.64677 },
  { lat: 57.63987, lon: -3.64652 },
  { lat: 57.64107, lon: -3.64419 },
  { lat: 57.64133, lon: -3.64464 },
  { lat: 57.64168, lon: -3.64368 },
  { lat: 57.64283, lon: -3.64278 },
  { lat: 57.64237, lon: -3.64398 },
  { lat: 57.64377, lon: -3.64185 },
  { lat: 57.64434, lon: -3.63794 },
  { lat: 57.64361, lon: -3.63241 },
  { lat: 57.64405, lon: -3.62641 },
  { lat: 57.64515, lon: -3.62245 },
  { lat: 57.64516, lon: -3.62433 },
  { lat: 57.64696, lon: -3.62609 },
  { lat: 57.64956, lon: -3.6247 },
  { lat: 57.65101, lon: -3.62222 },
  { lat: 57.65292, lon: -3.62254 },
  { lat: 57.65379, lon: -3.62189 },
  { lat: 57.6553, lon: -3.61972 },
  { lat: 57.65575, lon: -3.62162 },
  { lat: 57.65692, lon: -3.62304 },
  { lat: 57.65862, lon: -3.62412 },
  { lat: 57.65732, lon: -3.62203 },
  { lat: 57.65764, lon: -3.62182 },
  { lat: 57.65866, lon: -3.62332 },
  { lat: 57.66063, lon: -3.6301 },
  { lat: 57.66273, lon: -3.63383 },
  { lat: 57.6631, lon: -3.63788 },
  { lat: 57.66297, lon: -3.64994 },
  { lat: 57.65782, lon: -3.70169 },
  { lat: 57.65484, lon: -3.71574 },
  { lat: 57.64983, lon: -3.732 },
  { lat: 57.64835, lon: -3.73463 },
  { lat: 57.64796, lon: -3.7348 },
  { lat: 57.6479, lon: -3.73379 },
  { lat: 57.65046, lon: -3.72809 },
  { lat: 57.65191, lon: -3.72091 },
  { lat: 57.6527, lon: -3.7201 },
  { lat: 57.65343, lon: -3.71746 },
  { lat: 57.65304, lon: -3.71413 },
  { lat: 57.65347, lon: -3.71542 },
  { lat: 57.65528, lon: -3.70969 },
  { lat: 57.65487, lon: -3.70957 },
  { lat: 57.65503, lon: -3.70827 },
  { lat: 57.65389, lon: -3.70864 },
  { lat: 57.65351, lon: -3.70744 },
  { lat: 57.65287, lon: -3.70742 },
  { lat: 57.65197, lon: -3.70836 },
  { lat: 57.65161, lon: -3.70453 },
  { lat: 57.65084, lon: -3.70333 },
  { lat: 57.64855, lon: -3.70185 },
  { lat: 57.64752, lon: -3.70183 },
  { lat: 57.64675, lon: -3.70301 },
  { lat: 57.64298, lon: -3.71296 },
  { lat: 57.64063, lon: -3.72198 },
  { lat: 57.63763, lon: -3.731 },
  { lat: 57.63569, lon: -3.73477 },
  { lat: 57.63178, lon: -3.74567 },
  { lat: 57.6319, lon: -3.74806 },
  { lat: 57.63318, lon: -3.74809 },
  { lat: 57.63421, lon: -3.74692 },
  { lat: 57.63523, lon: -3.74694 },
  { lat: 57.63551, lon: -3.74432 },
  { lat: 57.63653, lon: -3.74434 },
  { lat: 57.63665, lon: -3.7453 },
  { lat: 57.63806, lon: -3.74509 },
  { lat: 57.63883, lon: -3.74439 },
  { lat: 57.64286, lon: -3.73444 },
  { lat: 57.6443, lon: -3.72922 },
  { lat: 57.64494, lon: -3.72875 },
  { lat: 57.64508, lon: -3.72637 },
  { lat: 57.64406, lon: -3.72563 },
  { lat: 57.64356, lon: -3.72443 },
  { lat: 57.64433, lon: -3.72301 },
  { lat: 57.64434, lon: -3.7211 },
  { lat: 57.64588, lon: -3.72185 },
  { lat: 57.64639, lon: -3.72114 },
  { lat: 57.64571, lon: -3.72877 },
  { lat: 57.64439, lon: -3.73543 },
  { lat: 57.64244, lon: -3.7404 },
  { lat: 57.6396, lon: -3.74392 },
  { lat: 57.63688, lon: -3.75007 },
  { lat: 57.63572, lon: -3.75148 },
  { lat: 57.63261, lon: -3.75762 },
  { lat: 57.62819, lon: -3.76946 },
  { lat: 57.62518, lon: -3.77942 },
  { lat: 57.62354, lon: -3.79609 },
  { lat: 57.62066, lon: -3.807 },
  { lat: 57.61663, lon: -3.81645 },
  { lat: 57.61145, lon: -3.82492 },
  { lat: 57.60965, lon: -3.82631 },
  { lat: 57.60861, lon: -3.82819 },
  { lat: 57.60784, lon: -3.82842 },
  { lat: 57.60372, lon: -3.83238 },
  { lat: 57.60373, lon: -3.83142 },
  { lat: 57.60528, lon: -3.8286 },
  { lat: 57.60684, lon: -3.82601 },
  { lat: 57.60838, lon: -3.82485 },
  { lat: 57.60865, lon: -3.82295 },
  { lat: 57.61084, lon: -3.82061 },
  { lat: 57.61175, lon: -3.81825 },
  { lat: 57.61343, lon: -3.8159 },
  { lat: 57.61539, lon: -3.81022 },
  { lat: 57.6159, lon: -3.80999 },
  { lat: 57.61669, lon: -3.80739 },
  { lat: 57.61694, lon: -3.80763 },
  { lat: 57.61747, lon: -3.80454 },
  { lat: 57.62018, lon: -3.80174 },
  { lat: 57.62032, lon: -3.79936 },
  { lat: 57.62096, lon: -3.79889 },
  { lat: 57.62214, lon: -3.7951 },
  { lat: 57.62361, lon: -3.78559 },
  { lat: 57.62323, lon: -3.78487 },
  { lat: 57.62105, lon: -3.78458 },
  { lat: 57.61935, lon: -3.79051 },
  { lat: 57.61703, lon: -3.79356 },
  { lat: 57.61482, lon: -3.79876 },
  { lat: 57.61263, lon: -3.80038 },
  { lat: 57.61059, lon: -3.79986 },
  { lat: 57.60982, lon: -3.80008 },
  { lat: 57.60993, lon: -3.80342 },
  { lat: 57.61068, lon: -3.80582 },
  { lat: 57.60847, lon: -3.81102 },
  { lat: 57.60718, lon: -3.81218 },
  { lat: 57.60575, lon: -3.81525 },
  { lat: 57.60511, lon: -3.81595 },
  { lat: 57.6047, lon: -3.8155 },
  { lat: 57.59962, lon: -3.82582 },
  { lat: 57.5972, lon: -3.83256 },
  { lat: 57.59714, lon: -3.83413 },
  { lat: 57.59787, lon: -3.83677 },
  { lat: 57.59282, lon: -3.86002 },
  { lat: 57.59372, lon: -3.86058 },
  { lat: 57.59207, lon: -3.85995 },
  { lat: 57.59063, lon: -3.86008 },
  { lat: 57.5882, lon: -3.86183 },
  { lat: 57.58744, lon: -3.86298 },
  { lat: 57.59045, lon: -3.8608 },
  { lat: 57.58993, lon: -3.86145 },
  { lat: 57.59015, lon: -3.86253 },
  { lat: 57.59135, lon: -3.86168 },
  { lat: 57.59139, lon: -3.86096 },
  { lat: 57.59057, lon: -3.86098 },
  { lat: 57.5907, lon: -3.86067 },
  { lat: 57.59349, lon: -3.86081 },
  { lat: 57.59193, lon: -3.86076 },
  { lat: 57.59136, lon: -3.86269 },
  { lat: 57.59073, lon: -3.86317 },
  { lat: 57.59005, lon: -3.86734 },
  { lat: 57.58916, lon: -3.88448 },
  { lat: 57.58616, lon: -3.90968 },
  { lat: 57.58585, lon: -3.9173 },
  { lat: 57.58657, lon: -3.92446 },
  { lat: 57.5858, lon: -3.92986 },
  { lat: 57.58647, lon: -3.93781 },
  { lat: 57.58833, lon: -3.94644 },
  { lat: 57.59138, lon: -3.96559 },
  { lat: 57.60184, lon: -4.00039 },
  { lat: 57.60297, lon: -4.00744 },
  { lat: 57.60288, lon: -4.00804 },
  { lat: 57.60226, lon: -4.00585 },
  { lat: 57.60052, lon: -3.99649 },
  { lat: 57.59951, lon: -3.9947 },
  { lat: 57.59648, lon: -3.98488 },
  { lat: 57.59382, lon: -3.98091 },
  { lat: 57.59193, lon: -3.97534 },
  { lat: 57.58913, lon: -3.97081 },
  { lat: 57.5887, lon: -3.96864 },
  { lat: 57.58882, lon: -3.97046 },
  { lat: 57.58846, lon: -3.97096 },
  { lat: 57.59143, lon: -3.97608 },
  { lat: 57.59192, lon: -3.97915 },
  { lat: 57.59244, lon: -3.97945 },
  { lat: 57.59336, lon: -3.98305 },
  { lat: 57.59301, lon: -3.9843 },
  { lat: 57.5934, lon: -3.98614 },
  { lat: 57.59428, lon: -3.98578 },
  { lat: 57.59919, lon: -4.0023 },
  { lat: 57.59892, lon: -4.00344 },
  { lat: 57.59939, lon: -4.00586 },
  { lat: 57.60005, lon: -4.00633 },
  { lat: 57.60028, lon: -4.00597 },
  { lat: 57.60054, lon: -4.00666 },
  { lat: 57.59998, lon: -4.00763 },
  { lat: 57.60038, lon: -4.00856 },
  { lat: 57.60031, lon: -4.01076 },
  { lat: 57.60245, lon: -4.01306 },
  { lat: 57.60206, lon: -4.01419 },
  { lat: 57.60034, lon: -4.01511 },
  { lat: 57.60094, lon: -4.01467 },
  { lat: 57.60067, lon: -4.01359 },
  { lat: 57.6013, lon: -4.01449 },
  { lat: 57.60167, lon: -4.01416 },
  { lat: 57.60144, lon: -4.01291 },
  { lat: 57.60181, lon: -4.0134 },
  { lat: 57.60212, lon: -4.01285 },
  { lat: 57.60028, lon: -4.01121 },
  { lat: 57.59879, lon: -4.01774 },
  { lat: 57.59774, lon: -4.0194 },
  { lat: 57.59548, lon: -4.01975 },
  { lat: 57.59502, lon: -4.01884 },
  { lat: 57.59412, lon: -4.019 },
  { lat: 57.59337, lon: -4.01847 },
  { lat: 57.59372, lon: -4.01809 },
  { lat: 57.59451, lon: -4.0187 },
  { lat: 57.59518, lon: -4.01822 },
  { lat: 57.59515, lon: -4.01653 },
  { lat: 57.59425, lon: -4.01519 },
  { lat: 57.59317, lon: -4.0157 },
  { lat: 57.59215, lon: -4.01904 },
  { lat: 57.59143, lon: -4.02563 },
  { lat: 57.59134, lon: -4.03567 },
  { lat: 57.59204, lon: -4.04427 },
  { lat: 57.59123, lon: -4.04902 },
  { lat: 57.59115, lon: -4.05807 },
  { lat: 57.59076, lon: -4.05949 },
  { lat: 57.58921, lon: -4.0604 },
  { lat: 57.58921, lon: -4.06136 },
  { lat: 57.58792, lon: -4.06227 },
  { lat: 57.58508, lon: -4.07204 },
  { lat: 57.58338, lon: -4.07616 },
  { lat: 57.58248, lon: -4.07642 },
  { lat: 57.58147, lon: -4.07034 },
  { lat: 57.5827, lon: -4.06622 },
  { lat: 57.5824, lon: -4.06004 },
  { lat: 57.57948, lon: -4.05219 },
  { lat: 57.57683, lon: -4.04751 },
  { lat: 57.57325, lon: -4.04271 },
  { lat: 57.56917, lon: -4.03909 },
  { lat: 57.56712, lon: -4.03856 },
  { lat: 57.56531, lon: -4.03969 },
  { lat: 57.56348, lon: -4.03959 },
  { lat: 57.56028, lon: -4.04066 },
  { lat: 57.55932, lon: -4.04306 },
  { lat: 57.55656, lon: -4.04588 },
  { lat: 57.55297, lon: -4.05214 },
  { lat: 57.54745, lon: -4.06808 },
  { lat: 57.5454, lon: -4.07601 },
  { lat: 57.5434, lon: -4.08069 },
  { lat: 57.53907, lon: -4.09539 },
  { lat: 57.53508, lon: -4.10238 },
  { lat: 57.53355, lon: -4.10428 },
  { lat: 57.52384, lon: -4.11272 },
  { lat: 57.51936, lon: -4.1185 },
  { lat: 57.51872, lon: -4.11453 },
  { lat: 57.51993, lon: -4.11239 },
  { lat: 57.52066, lon: -4.10924 },
  { lat: 57.52049, lon: -4.10762 },
  { lat: 57.51966, lon: -4.10717 },
  { lat: 57.5182, lon: -4.11096 },
  { lat: 57.51608, lon: -4.11277 },
  { lat: 57.515, lon: -4.1192 },
  { lat: 57.51478, lon: -4.1281 },
  { lat: 57.51752, lon: -4.14501 },
  { lat: 57.51845, lon: -4.14738 },
  { lat: 57.51624, lon: -4.14953 },
  { lat: 57.51353, lon: -4.15034 },
  { lat: 57.51168, lon: -4.15021 },
  { lat: 57.50467, lon: -4.14755 },
  { lat: 57.50298, lon: -4.14762 },
  { lat: 57.5017, lon: -4.14832 },
  { lat: 57.50021, lon: -4.14996 },
  { lat: 57.49999, lon: -4.1519 },
  { lat: 57.49768, lon: -4.15432 },
  { lat: 57.49622, lon: -4.15704 },
  { lat: 57.49583, lon: -4.15644 },
  { lat: 57.49601, lon: -4.1574 },
  { lat: 57.4955, lon: -4.15736 },
  { lat: 57.49451, lon: -4.15944 },
  { lat: 57.49176, lon: -4.16256 },
  { lat: 57.48993, lon: -4.16565 },
  { lat: 57.48947, lon: -4.1673 },
  { lat: 57.48959, lon: -4.17046 },
  { lat: 57.48893, lon: -4.17092 },
  { lat: 57.48846, lon: -4.17064 },
  { lat: 57.48498, lon: -4.17938 },
  { lat: 57.48385, lon: -4.18681 },
  { lat: 57.48436, lon: -4.18784 },
  { lat: 57.48696, lon: -4.18801 },
  { lat: 57.488, lon: -4.18858 },
  { lat: 57.48976, lon: -4.19173 },
  { lat: 57.48978, lon: -4.19345 },
  { lat: 57.48725, lon: -4.19645 },
  { lat: 57.48975, lon: -4.19384 },
  { lat: 57.48853, lon: -4.19585 },
  { lat: 57.49336, lon: -4.20651 },
  { lat: 57.49445, lon: -4.20746 },
  { lat: 57.495, lon: -4.20882 },
  { lat: 57.49363, lon: -4.20745 },
  { lat: 57.49297, lon: -4.20993 },
  { lat: 57.49336, lon: -4.21079 },
  { lat: 57.49403, lon: -4.21066 },
  { lat: 57.49399, lon: -4.21184 },
  { lat: 57.49468, lon: -4.21244 },
  { lat: 57.49512, lon: -4.2106 },
  { lat: 57.49486, lon: -4.21283 },
  { lat: 57.49676, lon: -4.22092 },
  { lat: 57.49412, lon: -4.22899 },
  { lat: 57.49506, lon: -4.23326 },
  { lat: 57.49571, lon: -4.23434 },
  { lat: 57.49447, lon: -4.23529 },
  { lat: 57.49506, lon: -4.23426 },
  { lat: 57.4944, lon: -4.23196 },
  { lat: 57.49328, lon: -4.23309 },
  { lat: 57.49408, lon: -4.23517 },
  { lat: 57.49287, lon: -4.23637 },
  { lat: 57.49274, lon: -4.23778 },
  { lat: 57.49279, lon: -4.23901 },
  { lat: 57.49531, lon: -4.23718 },
  { lat: 57.49557, lon: -4.23742 },
  { lat: 57.4942, lon: -4.23863 },
  { lat: 57.4937, lon: -4.2403 },
  { lat: 57.49467, lon: -4.24227 },
  { lat: 57.49529, lon: -4.24641 },
  { lat: 57.49434, lon: -4.24635 },
  { lat: 57.49047, lon: -4.25114 },
  { lat: 57.4896, lon: -4.25633 },
  { lat: 57.49082, lon: -4.2632 },
  { lat: 57.49041, lon: -4.26348 },
  { lat: 57.4895, lon: -4.25907 },
  { lat: 57.48904, lon: -4.25927 },
  { lat: 57.48866, lon: -4.26187 },
  { lat: 57.48704, lon: -4.266 },
  { lat: 57.48199, lon: -4.28456 },
  { lat: 57.48122, lon: -4.28869 },
  { lat: 57.48117, lon: -4.2934 },
  { lat: 57.48271, lon: -4.30024 },
  { lat: 57.48359, lon: -4.30691 },
  { lat: 57.4834, lon: -4.30962 },
  { lat: 57.48112, lon: -4.31329 },
  { lat: 57.48118, lon: -4.31438 },
  { lat: 57.48016, lon: -4.31482 },
  { lat: 57.48012, lon: -4.31547 },
  { lat: 57.48139, lon: -4.31794 },
  { lat: 57.48243, lon: -4.31806 },
  { lat: 57.4827, lon: -4.31865 },
  { lat: 57.48255, lon: -4.32067 },
  { lat: 57.48364, lon: -4.32315 },
  { lat: 57.48354, lon: -4.32513 },
  { lat: 57.48459, lon: -4.32736 },
  { lat: 57.48466, lon: -4.32996 },
  { lat: 57.48169, lon: -4.35381 },
  { lat: 57.48246, lon: -4.36345 },
  { lat: 57.48214, lon: -4.3642 },
  { lat: 57.48122, lon: -4.36416 },
  { lat: 57.48075, lon: -4.3649 },
  { lat: 57.48077, lon: -4.36783 },
  { lat: 57.47954, lon: -4.37522 },
  { lat: 57.47989, lon: -4.37808 },
  { lat: 57.48142, lon: -4.37909 },
  { lat: 57.48165, lon: -4.381 },
  { lat: 57.48216, lon: -4.38102 },
  { lat: 57.482, lon: -4.38434 },
  { lat: 57.48237, lon: -4.38531 },
  { lat: 57.48314, lon: -4.38557 },
  { lat: 57.4849, lon: -4.38802 },
  { lat: 57.48592, lon: -4.38853 },
  { lat: 57.48769, lon: -4.39074 },
  { lat: 57.48793, lon: -4.39217 },
  { lat: 57.48946, lon: -4.39271 },
  { lat: 57.48945, lon: -4.39366 },
  { lat: 57.49091, lon: -4.39427 },
  { lat: 57.49152, lon: -4.39733 },
  { lat: 57.49278, lon: -4.39952 },
];

export const MORAY_FIRTH_ISLANDS: ReadonlyArray<ReadonlyArray<LatLon>> = [
  [
    { lat: 57.61387, lon: -4.39982 },
    { lat: 57.61578, lon: -4.39557 },
    { lat: 57.61825, lon: -4.39185 },
    { lat: 57.62011, lon: -4.38749 },
    { lat: 57.62039, lon: -4.38521 },
    { lat: 57.62262, lon: -4.38215 },
    { lat: 57.62444, lon: -4.37837 },
    { lat: 57.62607, lon: -4.37344 },
    { lat: 57.62677, lon: -4.36911 },
    { lat: 57.62682, lon: -4.36715 },
    { lat: 57.62597, lon: -4.36677 },
    { lat: 57.62593, lon: -4.36629 },
    { lat: 57.62722, lon: -4.36652 },
    { lat: 57.62711, lon: -4.36541 },
    { lat: 57.62746, lon: -4.36524 },
    { lat: 57.62852, lon: -4.36676 },
    { lat: 57.62929, lon: -4.36679 },
    { lat: 57.62955, lon: -4.36609 },
    { lat: 57.63109, lon: -4.36543 },
    { lat: 57.63369, lon: -4.36218 },
    { lat: 57.63643, lon: -4.3568 },
    { lat: 57.63684, lon: -4.3549 },
    { lat: 57.63748, lon: -4.35445 },
    { lat: 57.63964, lon: -4.3498 },
    { lat: 57.64001, lon: -4.34708 },
    { lat: 57.64155, lon: -4.34731 },
    { lat: 57.64391, lon: -4.34286 },
    { lat: 57.64491, lon: -4.34255 },
    { lat: 57.64793, lon: -4.33989 },
    { lat: 57.64982, lon: -4.33765 },
    { lat: 57.6523, lon: -4.33303 },
    { lat: 57.65429, lon: -4.32638 },
    { lat: 57.65562, lon: -4.32462 },
    { lat: 57.65499, lon: -4.32119 },
    { lat: 57.65374, lon: -4.3178 },
    { lat: 57.65468, lon: -4.31419 },
    { lat: 57.65563, lon: -4.31299 },
    { lat: 57.65599, lon: -4.30553 },
    { lat: 57.65669, lon: -4.30422 },
    { lat: 57.6588, lon: -4.3024 },
    { lat: 57.65893, lon: -4.30027 },
    { lat: 57.65932, lon: -4.29994 },
    { lat: 57.66011, lon: -4.30076 },
    { lat: 57.66122, lon: -4.30064 },
    { lat: 57.66198, lon: -4.30138 },
    { lat: 57.66225, lon: -4.30258 },
    { lat: 57.66276, lon: -4.30245 },
    { lat: 57.66392, lon: -4.30022 },
    { lat: 57.6636, lon: -4.29811 },
    { lat: 57.66414, lon: -4.29957 },
    { lat: 57.66443, lon: -4.29897 },
    { lat: 57.66407, lon: -4.29759 },
    { lat: 57.66489, lon: -4.29878 },
    { lat: 57.66462, lon: -4.27949 },
    { lat: 57.66504, lon: -4.27941 },
    { lat: 57.66541, lon: -4.29917 },
    { lat: 57.66808, lon: -4.30036 },
    { lat: 57.66801, lon: -4.29847 },
    { lat: 57.66839, lon: -4.29825 },
    { lat: 57.66859, lon: -4.3008 },
    { lat: 57.67039, lon: -4.30127 },
    { lat: 57.67109, lon: -4.30211 },
    { lat: 57.67243, lon: -4.30211 },
    { lat: 57.67504, lon: -4.30113 },
    { lat: 57.67571, lon: -4.30015 },
    { lat: 57.67498, lon: -4.29961 },
    { lat: 57.67603, lon: -4.29935 },
    { lat: 57.67634, lon: -4.29972 },
    { lat: 57.67674, lon: -4.29923 },
    { lat: 57.67881, lon: -4.29318 },
    { lat: 57.68092, lon: -4.28963 },
    { lat: 57.68277, lon: -4.28348 },
    { lat: 57.68332, lon: -4.27968 },
    { lat: 57.68245, lon: -4.27758 },
    { lat: 57.68286, lon: -4.27449 },
    { lat: 57.68134, lon: -4.27292 },
    { lat: 57.67861, lon: -4.26422 },
    { lat: 57.67844, lon: -4.2553 },
    { lat: 57.67943, lon: -4.25283 },
    { lat: 57.68063, lon: -4.25155 },
    { lat: 57.67856, lon: -4.25528 },
    { lat: 57.67909, lon: -4.25579 },
    { lat: 57.67859, lon: -4.25623 },
    { lat: 57.67852, lon: -4.26177 },
    { lat: 57.67929, lon: -4.26167 },
    { lat: 57.67921, lon: -4.26514 },
    { lat: 57.67974, lon: -4.26516 },
    { lat: 57.67908, lon: -4.25892 },
    { lat: 57.67977, lon: -4.25679 },
    { lat: 57.68061, lon: -4.25617 },
    { lat: 57.68079, lon: -4.25487 },
    { lat: 57.68125, lon: -4.25499 },
    { lat: 57.68158, lon: -4.25239 },
    { lat: 57.68096, lon: -4.25112 },
    { lat: 57.68337, lon: -4.25259 },
    { lat: 57.68228, lon: -4.25121 },
    { lat: 57.68141, lon: -4.24889 },
    { lat: 57.68215, lon: -4.25118 },
    { lat: 57.68092, lon: -4.25022 },
    { lat: 57.68084, lon: -4.24963 },
    { lat: 57.68133, lon: -4.24998 },
    { lat: 57.68077, lon: -4.24861 },
    { lat: 57.68123, lon: -4.24765 },
    { lat: 57.68221, lon: -4.24785 },
    { lat: 57.68255, lon: -4.24675 },
    { lat: 57.68383, lon: -4.2468 },
    { lat: 57.68367, lon: -4.24345 },
    { lat: 57.68, lon: -4.23811 },
    { lat: 57.68411, lon: -4.24344 },
    { lat: 57.6845, lon: -4.24214 },
    { lat: 57.68519, lon: -4.24161 },
    { lat: 57.68614, lon: -4.2417 },
    { lat: 57.68616, lon: -4.24232 },
    { lat: 57.68653, lon: -4.24229 },
    { lat: 57.68758, lon: -4.23947 },
    { lat: 57.68801, lon: -4.23942 },
    { lat: 57.6883, lon: -4.23515 },
    { lat: 57.68973, lon: -4.23218 },
    { lat: 57.69037, lon: -4.22947 },
    { lat: 57.69047, lon: -4.22776 },
    { lat: 57.68983, lon: -4.2269 },
    { lat: 57.69048, lon: -4.22733 },
    { lat: 57.69082, lon: -4.22505 },
    { lat: 57.69068, lon: -4.21986 },
    { lat: 57.69116, lon: -4.21457 },
    { lat: 57.69038, lon: -4.21287 },
    { lat: 57.69101, lon: -4.21314 },
    { lat: 57.6912, lon: -4.21268 },
    { lat: 57.69264, lon: -4.20574 },
    { lat: 57.6912, lon: -4.19005 },
    { lat: 57.68901, lon: -4.18054 },
    { lat: 57.68852, lon: -4.18002 },
    { lat: 57.68728, lon: -4.18023 },
    { lat: 57.68661, lon: -4.17986 },
    { lat: 57.68633, lon: -4.18579 },
    { lat: 57.68413, lon: -4.18542 },
    { lat: 57.68439, lon: -4.1792 },
    { lat: 57.68694, lon: -4.17902 },
    { lat: 57.68696, lon: -4.1765 },
    { lat: 57.6855, lon: -4.17641 },
    { lat: 57.68516, lon: -4.17279 },
    { lat: 57.68475, lon: -4.17261 },
    { lat: 57.68515, lon: -4.16781 },
    { lat: 57.68565, lon: -4.16793 },
    { lat: 57.68562, lon: -4.16836 },
    { lat: 57.68621, lon: -4.16828 },
    { lat: 57.68625, lon: -4.16748 },
    { lat: 57.68559, lon: -4.16708 },
    { lat: 57.68645, lon: -4.16745 },
    { lat: 57.68666, lon: -4.16697 },
    { lat: 57.68856, lon: -4.15951 },
    { lat: 57.6929, lon: -4.15329 },
    { lat: 57.69539, lon: -4.14775 },
    { lat: 57.69542, lon: -4.14641 },
    { lat: 57.68801, lon: -4.13964 },
    { lat: 57.68785, lon: -4.13781 },
    { lat: 57.68838, lon: -4.13977 },
    { lat: 57.69548, lon: -4.14626 },
    { lat: 57.69643, lon: -4.14586 },
    { lat: 57.70426, lon: -4.13193 },
    { lat: 57.70502, lon: -4.12939 },
    { lat: 57.70747, lon: -4.12543 },
    { lat: 57.7118, lon: -4.11469 },
    { lat: 57.7126, lon: -4.11386 },
    { lat: 57.71348, lon: -4.11383 },
    { lat: 57.71857, lon: -4.10826 },
    { lat: 57.71928, lon: -4.10382 },
    { lat: 57.72069, lon: -4.10257 },
    { lat: 57.724, lon: -4.09258 },
    { lat: 57.72509, lon: -4.09136 },
    { lat: 57.7282, lon: -4.08465 },
    { lat: 57.73228, lon: -4.07308 },
    { lat: 57.73089, lon: -4.0598 },
    { lat: 57.72972, lon: -4.0583 },
    { lat: 57.72998, lon: -4.05466 },
    { lat: 57.72957, lon: -4.05401 },
    { lat: 57.73019, lon: -4.05367 },
    { lat: 57.72968, lon: -4.05225 },
    { lat: 57.73005, lon: -4.05114 },
    { lat: 57.7294, lon: -4.0509 },
    { lat: 57.72937, lon: -4.0501 },
    { lat: 57.73034, lon: -4.04731 },
    { lat: 57.73161, lon: -4.0461 },
    { lat: 57.73378, lon: -4.04533 },
    { lat: 57.73379, lon: -4.04365 },
    { lat: 57.73534, lon: -4.04202 },
    { lat: 57.73561, lon: -4.04036 },
    { lat: 57.73613, lon: -4.04037 },
    { lat: 57.73614, lon: -4.03893 },
    { lat: 57.73702, lon: -4.03821 },
    { lat: 57.73729, lon: -4.03557 },
    { lat: 57.73681, lon: -4.03465 },
    { lat: 57.7376, lon: -4.0318 },
    { lat: 57.73739, lon: -4.02605 },
    { lat: 57.73767, lon: -4.02414 },
    { lat: 57.73831, lon: -4.02368 },
    { lat: 57.73784, lon: -4.0184 },
    { lat: 57.73655, lon: -4.01908 },
    { lat: 57.73568, lon: -4.01595 },
    { lat: 57.73609, lon: -4.01356 },
    { lat: 57.73738, lon: -4.0124 },
    { lat: 57.73866, lon: -4.0122 },
    { lat: 57.73866, lon: -4.01172 },
    { lat: 57.73713, lon: -4.0112 },
    { lat: 57.73714, lon: -4.01024 },
    { lat: 57.73534, lon: -4.01115 },
    { lat: 57.73507, lon: -4.01258 },
    { lat: 57.73405, lon: -4.01207 },
    { lat: 57.73406, lon: -4.01111 },
    { lat: 57.73304, lon: -4.01061 },
    { lat: 57.73305, lon: -4.00965 },
    { lat: 57.73202, lon: -4.01034 },
    { lat: 57.73125, lon: -4.0096 },
    { lat: 57.73099, lon: -4.01055 },
    { lat: 57.731, lon: -4.00959 },
    { lat: 57.72971, lon: -4.01051 },
    { lat: 57.7297, lon: -4.01147 },
    { lat: 57.72817, lon: -4.01119 },
    { lat: 57.72765, lon: -4.01165 },
    { lat: 57.72689, lon: -4.01115 },
    { lat: 57.72559, lon: -4.01375 },
    { lat: 57.72307, lon: -4.02132 },
    { lat: 57.72093, lon: -4.02274 },
    { lat: 57.71971, lon: -4.02533 },
    { lat: 57.71729, lon: -4.02667 },
    { lat: 57.71619, lon: -4.02609 },
    { lat: 57.71486, lon: -4.02636 },
    { lat: 57.71294, lon: -4.02507 },
    { lat: 57.7128, lon: -4.02704 },
    { lat: 57.7107, lon: -4.02963 },
    { lat: 57.70862, lon: -4.03111 },
    { lat: 57.70774, lon: -4.03101 },
    { lat: 57.7043, lon: -4.0335 },
    { lat: 57.70076, lon: -4.03404 },
    { lat: 57.69905, lon: -4.03601 },
    { lat: 57.69617, lon: -4.03584 },
    { lat: 57.69538, lon: -4.03768 },
    { lat: 57.69488, lon: -4.03566 },
    { lat: 57.69321, lon: -4.03531 },
    { lat: 57.69319, lon: -4.03465 },
    { lat: 57.69437, lon: -4.0347 },
    { lat: 57.69451, lon: -4.02811 },
    { lat: 57.69784, lon: -4.02879 },
    { lat: 57.69935, lon: -4.02873 },
    { lat: 57.69938, lon: -4.02824 },
    { lat: 57.69831, lon: -4.0276 },
    { lat: 57.69762, lon: -4.02528 },
    { lat: 57.69474, lon: -4.02529 },
    { lat: 57.69473, lon: -4.02603 },
    { lat: 57.69457, lon: -4.02491 },
    { lat: 57.69256, lon: -4.02479 },
    { lat: 57.69257, lon: -4.02396 },
    { lat: 57.69344, lon: -4.02393 },
    { lat: 57.69221, lon: -4.02068 },
    { lat: 57.69309, lon: -4.01232 },
    { lat: 57.69449, lon: -4.00678 },
    { lat: 57.69384, lon: -4.00208 },
    { lat: 57.69269, lon: -3.99921 },
    { lat: 57.6919, lon: -3.99521 },
    { lat: 57.69148, lon: -3.98664 },
    { lat: 57.69205, lon: -3.98428 },
    { lat: 57.69175, lon: -3.98376 },
    { lat: 57.69219, lon: -3.98371 },
    { lat: 57.69201, lon: -3.98267 },
    { lat: 57.69214, lon: -3.98344 },
    { lat: 57.69218, lon: -3.98251 },
    { lat: 57.69224, lon: -3.9832 },
    { lat: 57.6927, lon: -3.9821 },
    { lat: 57.69276, lon: -3.97953 },
    { lat: 57.69331, lon: -3.97917 },
    { lat: 57.69348, lon: -3.97779 },
    { lat: 57.69357, lon: -3.9783 },
    { lat: 57.69386, lon: -3.97775 },
    { lat: 57.69386, lon: -3.97648 },
    { lat: 57.69436, lon: -3.97524 },
    { lat: 57.69449, lon: -3.97569 },
    { lat: 57.69509, lon: -3.97535 },
    { lat: 57.69696, lon: -3.97267 },
    { lat: 57.69751, lon: -3.97089 },
    { lat: 57.69761, lon: -3.9712 },
    { lat: 57.69806, lon: -3.97093 },
    { lat: 57.698, lon: -3.97033 },
    { lat: 57.69922, lon: -3.96969 },
    { lat: 57.70082, lon: -3.96683 },
    { lat: 57.70224, lon: -3.96628 },
    { lat: 57.70273, lon: -3.9648 },
    { lat: 57.70573, lon: -3.96074 },
    { lat: 57.70871, lon: -3.95759 },
    { lat: 57.71194, lon: -3.95181 },
    { lat: 57.71297, lon: -3.9516 },
    { lat: 57.71374, lon: -3.95066 },
    { lat: 57.71479, lon: -3.94806 },
    { lat: 57.71918, lon: -3.94291 },
    { lat: 57.71944, lon: -3.94172 },
    { lat: 57.7228, lon: -3.93822 },
    { lat: 57.72357, lon: -3.938 },
    { lat: 57.72435, lon: -3.93635 },
    { lat: 57.72693, lon: -3.93378 },
    { lat: 57.72797, lon: -3.93166 },
    { lat: 57.7295, lon: -3.9317 },
    { lat: 57.73207, lon: -3.93081 },
    { lat: 57.73484, lon: -3.92757 },
    { lat: 57.73848, lon: -3.92457 },
    { lat: 57.73976, lon: -3.92215 },
    { lat: 57.74136, lon: -3.92051 },
    { lat: 57.74314, lon: -3.91956 },
    { lat: 57.74391, lon: -3.9182 },
    { lat: 57.74616, lon: -3.91752 },
    { lat: 57.74995, lon: -3.91798 },
    { lat: 57.7524, lon: -3.91695 },
    { lat: 57.75314, lon: -3.91548 },
    { lat: 57.75338, lon: -3.91326 },
    { lat: 57.75445, lon: -3.91239 },
    { lat: 57.75391, lon: -3.90957 },
    { lat: 57.75437, lon: -3.91185 },
    { lat: 57.75517, lon: -3.9113 },
    { lat: 57.75437, lon: -3.90899 },
    { lat: 57.75372, lon: -3.90914 },
    { lat: 57.75441, lon: -3.90882 },
    { lat: 57.75493, lon: -3.90999 },
    { lat: 57.75647, lon: -3.90834 },
    { lat: 57.76016, lon: -3.89967 },
    { lat: 57.76408, lon: -3.89568 },
    { lat: 57.76606, lon: -3.89458 },
    { lat: 57.76785, lon: -3.88967 },
    { lat: 57.76916, lon: -3.88772 },
    { lat: 57.77077, lon: -3.88636 },
    { lat: 57.77209, lon: -3.88244 },
    { lat: 57.77318, lon: -3.87674 },
    { lat: 57.77599, lon: -3.87159 },
    { lat: 57.78246, lon: -3.86428 },
    { lat: 57.78402, lon: -3.86144 },
    { lat: 57.7866, lon: -3.85839 },
    { lat: 57.78933, lon: -3.85334 },
    { lat: 57.79305, lon: -3.85015 },
    { lat: 57.7942, lon: -3.84859 },
    { lat: 57.7955, lon: -3.84865 },
    { lat: 57.79821, lon: -3.84548 },
    { lat: 57.79898, lon: -3.84382 },
    { lat: 57.80078, lon: -3.8418 },
    { lat: 57.80252, lon: -3.83754 },
    { lat: 57.80347, lon: -3.83673 },
    { lat: 57.80558, lon: -3.83318 },
    { lat: 57.80999, lon: -3.82885 },
    { lat: 57.81123, lon: -3.827 },
    { lat: 57.81212, lon: -3.82686 },
    { lat: 57.81333, lon: -3.8247 },
    { lat: 57.81641, lon: -3.82155 },
    { lat: 57.82033, lon: -3.81492 },
    { lat: 57.82126, lon: -3.81405 },
    { lat: 57.82296, lon: -3.81345 },
    { lat: 57.82303, lon: -3.81242 },
    { lat: 57.82323, lon: -3.81292 },
    { lat: 57.82496, lon: -3.81174 },
    { lat: 57.82675, lon: -3.80861 },
    { lat: 57.82944, lon: -3.80542 },
    { lat: 57.83115, lon: -3.80161 },
    { lat: 57.83358, lon: -3.79927 },
    { lat: 57.83644, lon: -3.79338 },
    { lat: 57.83682, lon: -3.79353 },
    { lat: 57.84076, lon: -3.78934 },
    { lat: 57.84213, lon: -3.78867 },
    { lat: 57.84441, lon: -3.78607 },
    { lat: 57.84621, lon: -3.78515 },
    { lat: 57.84958, lon: -3.7818 },
  ],
  [
    { lat: 57.5072, lon: -4.3999 },
    { lat: 57.50771, lon: -4.39971 },
    { lat: 57.50789, lon: -4.39818 },
    { lat: 57.50989, lon: -4.39338 },
    { lat: 57.51233, lon: -4.37544 },
    { lat: 57.51183, lon: -4.37345 },
    { lat: 57.50838, lon: -4.37208 },
    { lat: 57.51119, lon: -4.37289 },
    { lat: 57.51237, lon: -4.37086 },
    { lat: 57.51251, lon: -4.36947 },
    { lat: 57.51238, lon: -4.36824 },
    { lat: 57.51146, lon: -4.36687 },
    { lat: 57.51219, lon: -4.36312 },
    { lat: 57.51077, lon: -4.35643 },
    { lat: 57.50882, lon: -4.35089 },
    { lat: 57.50573, lon: -4.34481 },
    { lat: 57.50481, lon: -4.33478 },
    { lat: 57.50487, lon: -4.32908 },
    { lat: 57.50544, lon: -4.32757 },
    { lat: 57.50517, lon: -4.32481 },
    { lat: 57.50225, lon: -4.31043 },
    { lat: 57.50255, lon: -4.30569 },
    { lat: 57.50334, lon: -4.30381 },
    { lat: 57.50356, lon: -4.29478 },
    { lat: 57.50407, lon: -4.2948 },
    { lat: 57.50474, lon: -4.29245 },
    { lat: 57.50403, lon: -4.28671 },
    { lat: 57.50416, lon: -4.27388 },
    { lat: 57.50456, lon: -4.2727 },
    { lat: 57.50507, lon: -4.27248 },
    { lat: 57.50527, lon: -4.27094 },
    { lat: 57.50255, lon: -4.26072 },
    { lat: 57.50186, lon: -4.25072 },
    { lat: 57.50123, lon: -4.24809 },
    { lat: 57.50095, lon: -4.24822 },
    { lat: 57.5014, lon: -4.24783 },
    { lat: 57.50066, lon: -4.24464 },
    { lat: 57.50071, lon: -4.23437 },
    { lat: 57.50348, lon: -4.23379 },
    { lat: 57.50477, lon: -4.23219 },
    { lat: 57.50789, lon: -4.23049 },
    { lat: 57.51, lon: -4.22597 },
    { lat: 57.51258, lon: -4.22414 },
    { lat: 57.51593, lon: -4.2192 },
    { lat: 57.51705, lon: -4.21852 },
    { lat: 57.51805, lon: -4.21528 },
    { lat: 57.51835, lon: -4.21037 },
    { lat: 57.52028, lon: -4.21054 },
    { lat: 57.52082, lon: -4.21007 },
    { lat: 57.52572, lon: -4.20348 },
    { lat: 57.53157, lon: -4.19829 },
    { lat: 57.5325, lon: -4.19795 },
    { lat: 57.53476, lon: -4.19484 },
    { lat: 57.53682, lon: -4.19385 },
    { lat: 57.53934, lon: -4.19423 },
    { lat: 57.53999, lon: -4.19523 },
    { lat: 57.54087, lon: -4.19896 },
    { lat: 57.54264, lon: -4.2004 },
    { lat: 57.54359, lon: -4.20188 },
    { lat: 57.5437, lon: -4.20483 },
    { lat: 57.54301, lon: -4.20462 },
    { lat: 57.54236, lon: -4.20519 },
    { lat: 57.54164, lon: -4.20979 },
    { lat: 57.54224, lon: -4.21837 },
    { lat: 57.54457, lon: -4.22733 },
    { lat: 57.54582, lon: -4.22915 },
    { lat: 57.54629, lon: -4.2291 },
    { lat: 57.54697, lon: -4.23101 },
    { lat: 57.54582, lon: -4.24358 },
    { lat: 57.54501, lon: -4.24792 },
    { lat: 57.54629, lon: -4.24643 },
    { lat: 57.54765, lon: -4.24605 },
    { lat: 57.54749, lon: -4.25016 },
    { lat: 57.54932, lon: -4.25193 },
    { lat: 57.54989, lon: -4.24807 },
    { lat: 57.55198, lon: -4.24085 },
    { lat: 57.55182, lon: -4.2361 },
    { lat: 57.55097, lon: -4.23103 },
    { lat: 57.55121, lon: -4.22473 },
    { lat: 57.55048, lon: -4.22219 },
    { lat: 57.55033, lon: -4.21933 },
    { lat: 57.54897, lon: -4.21638 },
    { lat: 57.54963, lon: -4.21429 },
    { lat: 57.54883, lon: -4.21025 },
    { lat: 57.54898, lon: -4.20981 },
    { lat: 57.54964, lon: -4.2099 },
    { lat: 57.54893, lon: -4.20914 },
    { lat: 57.54805, lon: -4.19754 },
    { lat: 57.54602, lon: -4.19365 },
    { lat: 57.54575, lon: -4.18722 },
    { lat: 57.54691, lon: -4.18299 },
    { lat: 57.54857, lon: -4.18209 },
    { lat: 57.54908, lon: -4.18082 },
    { lat: 57.55165, lon: -4.17846 },
    { lat: 57.55317, lon: -4.17547 },
    { lat: 57.55463, lon: -4.17505 },
    { lat: 57.55721, lon: -4.17641 },
    { lat: 57.56003, lon: -4.17641 },
    { lat: 57.56445, lon: -4.17362 },
    { lat: 57.5668, lon: -4.16886 },
    { lat: 57.56652, lon: -4.16608 },
    { lat: 57.56707, lon: -4.16546 },
    { lat: 57.56646, lon: -4.16689 },
    { lat: 57.56722, lon: -4.16776 },
    { lat: 57.5678, lon: -4.16567 },
    { lat: 57.56717, lon: -4.16544 },
    { lat: 57.56782, lon: -4.16563 },
    { lat: 57.57142, lon: -4.15717 },
    { lat: 57.57364, lon: -4.14945 },
    { lat: 57.57554, lon: -4.14604 },
    { lat: 57.5774, lon: -4.14082 },
    { lat: 57.57844, lon: -4.13608 },
    { lat: 57.57833, lon: -4.13368 },
    { lat: 57.57874, lon: -4.13466 },
    { lat: 57.57868, lon: -4.1339 },
    { lat: 57.57906, lon: -4.13409 },
    { lat: 57.57941, lon: -4.13313 },
    { lat: 57.57856, lon: -4.12615 },
    { lat: 57.5785, lon: -4.11502 },
    { lat: 57.57752, lon: -4.10844 },
    { lat: 57.57325, lon: -4.09402 },
    { lat: 57.57408, lon: -4.09111 },
    { lat: 57.57565, lon: -4.09626 },
    { lat: 57.57823, lon: -4.10156 },
    { lat: 57.58357, lon: -4.10853 },
    { lat: 57.58877, lon: -4.11238 },
    { lat: 57.59039, lon: -4.11287 },
    { lat: 57.59446, lon: -4.11256 },
    { lat: 57.59682, lon: -4.10681 },
    { lat: 57.5985, lon: -4.10527 },
    { lat: 57.60737, lon: -4.10211 },
    { lat: 57.6118, lon: -4.09436 },
    { lat: 57.61689, lon: -4.08769 },
    { lat: 57.61984, lon: -4.0822 },
    { lat: 57.62193, lon: -4.08021 },
    { lat: 57.62403, lon: -4.07462 },
    { lat: 57.62606, lon: -4.07055 },
    { lat: 57.6262, lon: -4.07096 },
    { lat: 57.62685, lon: -4.07 },
    { lat: 57.62697, lon: -4.06895 },
    { lat: 57.62927, lon: -4.06647 },
    { lat: 57.63147, lon: -4.06507 },
    { lat: 57.63207, lon: -4.06401 },
    { lat: 57.63297, lon: -4.06395 },
    { lat: 57.63464, lon: -4.06268 },
    { lat: 57.63852, lon: -4.05694 },
    { lat: 57.64075, lon: -4.05143 },
    { lat: 57.64333, lon: -4.04885 },
    { lat: 57.64487, lon: -4.04889 },
    { lat: 57.64662, lon: -4.04646 },
    { lat: 57.6473, lon: -4.04444 },
    { lat: 57.65025, lon: -4.04011 },
    { lat: 57.65331, lon: -4.03171 },
    { lat: 57.65867, lon: -4.02513 },
    { lat: 57.65878, lon: -4.02279 },
    { lat: 57.65994, lon: -4.01978 },
    { lat: 57.65983, lon: -4.01823 },
    { lat: 57.66118, lon: -4.01557 },
    { lat: 57.66231, lon: -4.01156 },
    { lat: 57.66815, lon: -4.00347 },
    { lat: 57.66831, lon: -4.00227 },
    { lat: 57.66953, lon: -4.00225 },
    { lat: 57.67136, lon: -4.00007 },
    { lat: 57.67263, lon: -3.99984 },
    { lat: 57.67357, lon: -3.99641 },
    { lat: 57.67558, lon: -3.99529 },
    { lat: 57.67637, lon: -3.99343 },
    { lat: 57.67715, lon: -3.99402 },
    { lat: 57.6774, lon: -3.99346 },
    { lat: 57.67752, lon: -3.99437 },
    { lat: 57.67765, lon: -3.99392 },
    { lat: 57.67771, lon: -3.99548 },
    { lat: 57.67919, lon: -3.99728 },
    { lat: 57.67911, lon: -3.99843 },
    { lat: 57.67981, lon: -3.99844 },
    { lat: 57.6801, lon: -4.00097 },
    { lat: 57.67879, lon: -4.02115 },
    { lat: 57.67949, lon: -4.02689 },
    { lat: 57.68354, lon: -4.03474 },
    { lat: 57.68402, lon: -4.03702 },
    { lat: 57.68336, lon: -4.03895 },
    { lat: 57.68333, lon: -4.03761 },
    { lat: 57.68276, lon: -4.03788 },
    { lat: 57.68337, lon: -4.03922 },
    { lat: 57.68299, lon: -4.0401 },
    { lat: 57.68272, lon: -4.03792 },
    { lat: 57.68213, lon: -4.03809 },
    { lat: 57.6797, lon: -4.03972 },
    { lat: 57.67782, lon: -4.04213 },
    { lat: 57.67649, lon: -4.0472 },
    { lat: 57.67585, lon: -4.05678 },
    { lat: 57.6751, lon: -4.05959 },
    { lat: 57.67275, lon: -4.06573 },
    { lat: 57.67008, lon: -4.07098 },
    { lat: 57.66659, lon: -4.08275 },
    { lat: 57.6649, lon: -4.08556 },
    { lat: 57.66409, lon: -4.09032 },
    { lat: 57.66411, lon: -4.09703 },
    { lat: 57.66334, lon: -4.1059 },
    { lat: 57.65972, lon: -4.12219 },
    { lat: 57.65922, lon: -4.12865 },
    { lat: 57.65967, lon: -4.13286 },
    { lat: 57.65898, lon: -4.13573 },
    { lat: 57.65872, lon: -4.1417 },
    { lat: 57.65963, lon: -4.14679 },
    { lat: 57.6576, lon: -4.15408 },
    { lat: 57.65731, lon: -4.1599 },
    { lat: 57.65743, lon: -4.16083 },
    { lat: 57.65787, lon: -4.15981 },
    { lat: 57.65836, lon: -4.16031 },
    { lat: 57.65817, lon: -4.16182 },
    { lat: 57.65936, lon: -4.16319 },
    { lat: 57.65927, lon: -4.1648 },
    { lat: 57.65981, lon: -4.16524 },
    { lat: 57.66022, lon: -4.16422 },
    { lat: 57.66047, lon: -4.16568 },
    { lat: 57.66124, lon: -4.16547 },
    { lat: 57.66258, lon: -4.16631 },
    { lat: 57.66313, lon: -4.16786 },
    { lat: 57.6635, lon: -4.16705 },
    { lat: 57.66533, lon: -4.16711 },
    { lat: 57.66677, lon: -4.16545 },
    { lat: 57.66989, lon: -4.1639 },
    { lat: 57.67339, lon: -4.16403 },
    { lat: 57.6759, lon: -4.16537 },
    { lat: 57.67501, lon: -4.1743 },
    { lat: 57.67526, lon: -4.17731 },
    { lat: 57.67463, lon: -4.18089 },
    { lat: 57.67474, lon: -4.18775 },
    { lat: 57.67397, lon: -4.19041 },
    { lat: 57.67242, lon: -4.20589 },
    { lat: 57.67258, lon: -4.20833 },
    { lat: 57.67412, lon: -4.21463 },
    { lat: 57.67334, lon: -4.21573 },
    { lat: 57.67201, lon: -4.22115 },
    { lat: 57.67133, lon: -4.22634 },
    { lat: 57.66992, lon: -4.23232 },
    { lat: 57.66931, lon: -4.23334 },
    { lat: 57.66942, lon: -4.23477 },
    { lat: 57.66571, lon: -4.24755 },
    { lat: 57.66246, lon: -4.25269 },
    { lat: 57.6614, lon: -4.256 },
    { lat: 57.66089, lon: -4.25598 },
    { lat: 57.66062, lon: -4.25788 },
    { lat: 57.6601, lon: -4.25786 },
    { lat: 57.65983, lon: -4.25929 },
    { lat: 57.65932, lon: -4.25927 },
    { lat: 57.65826, lon: -4.26306 },
    { lat: 57.65697, lon: -4.26444 },
    { lat: 57.6567, lon: -4.26587 },
    { lat: 57.65593, lon: -4.26584 },
    { lat: 57.65592, lon: -4.26679 },
    { lat: 57.65515, lon: -4.26677 },
    { lat: 57.6546, lon: -4.27009 },
    { lat: 57.65358, lon: -4.27053 },
    { lat: 57.6533, lon: -4.27243 },
    { lat: 57.65279, lon: -4.27242 },
    { lat: 57.65174, lon: -4.27525 },
    { lat: 57.65122, lon: -4.27523 },
    { lat: 57.65068, lon: -4.27855 },
    { lat: 57.65017, lon: -4.27853 },
    { lat: 57.65016, lon: -4.27949 },
    { lat: 57.64965, lon: -4.27947 },
    { lat: 57.64963, lon: -4.28138 },
    { lat: 57.64911, lon: -4.28136 },
    { lat: 57.64858, lon: -4.28325 },
    { lat: 57.64573, lon: -4.28724 },
    { lat: 57.64448, lon: -4.29205 },
    { lat: 57.64151, lon: -4.29845 },
    { lat: 57.63954, lon: -4.30487 },
    { lat: 57.63077, lon: -4.32512 },
    { lat: 57.62704, lon: -4.33082 },
    { lat: 57.62375, lon: -4.33389 },
    { lat: 57.62132, lon: -4.3378 },
    { lat: 57.6195, lon: -4.33966 },
    { lat: 57.61641, lon: -4.34399 },
    { lat: 57.61602, lon: -4.34613 },
    { lat: 57.61381, lon: -4.34831 },
    { lat: 57.61313, lon: -4.35076 },
    { lat: 57.61157, lon: -4.35188 },
    { lat: 57.6118, lon: -4.35596 },
    { lat: 57.61359, lon: -4.35865 },
    { lat: 57.60997, lon: -4.35507 },
    { lat: 57.60632, lon: -4.35973 },
    { lat: 57.60575, lon: -4.36137 },
    { lat: 57.60478, lon: -4.36199 },
    { lat: 57.60339, lon: -4.36452 },
    { lat: 57.6016, lon: -4.36642 },
    { lat: 57.5962, lon: -4.37761 },
    { lat: 57.59568, lon: -4.37756 },
    { lat: 57.59392, lon: -4.38059 },
    { lat: 57.59378, lon: -4.3817 },
    { lat: 57.59302, lon: -4.38202 },
    { lat: 57.59313, lon: -4.38332 },
    { lat: 57.59142, lon: -4.38593 },
    { lat: 57.59064, lon: -4.39046 },
    { lat: 57.58977, lon: -4.39325 },
    { lat: 57.58914, lon: -4.39392 },
    { lat: 57.58749, lon: -4.39983 },
  ],
  [
    { lat: 57.84966, lon: -3.81947 },
    { lat: 57.84836, lon: -3.82128 },
    { lat: 57.84591, lon: -3.82132 },
    { lat: 57.84518, lon: -3.82188 },
    { lat: 57.84261, lon: -3.82585 },
    { lat: 57.84247, lon: -3.82551 },
    { lat: 57.84247, lon: -3.82627 },
    { lat: 57.8411, lon: -3.82686 },
    { lat: 57.83998, lon: -3.82875 },
    { lat: 57.83871, lon: -3.82861 },
    { lat: 57.83775, lon: -3.82999 },
    { lat: 57.83823, lon: -3.82858 },
    { lat: 57.83691, lon: -3.82792 },
    { lat: 57.83554, lon: -3.82822 },
    { lat: 57.83414, lon: -3.83132 },
    { lat: 57.83363, lon: -3.8338 },
    { lat: 57.83344, lon: -3.83999 },
    { lat: 57.83127, lon: -3.84506 },
    { lat: 57.83066, lon: -3.84909 },
    { lat: 57.82945, lon: -3.84967 },
    { lat: 57.82529, lon: -3.85646 },
    { lat: 57.82273, lon: -3.87182 },
    { lat: 57.82343, lon: -3.88412 },
    { lat: 57.82247, lon: -3.88697 },
    { lat: 57.82158, lon: -3.88719 },
    { lat: 57.82137, lon: -3.88813 },
    { lat: 57.82086, lon: -3.89589 },
    { lat: 57.82273, lon: -3.90982 },
    { lat: 57.82051, lon: -3.91863 },
    { lat: 57.8185, lon: -3.91841 },
    { lat: 57.81722, lon: -3.91985 },
    { lat: 57.81578, lon: -3.93076 },
    { lat: 57.81688, lon: -3.93899 },
    { lat: 57.81648, lon: -3.94089 },
    { lat: 57.81546, lon: -3.94015 },
    { lat: 57.8147, lon: -3.93845 },
    { lat: 57.81417, lon: -3.94083 },
    { lat: 57.81469, lon: -3.94085 },
    { lat: 57.81391, lon: -3.94227 },
    { lat: 57.81402, lon: -3.94467 },
    { lat: 57.8128, lon: -3.94825 },
    { lat: 57.81256, lon: -3.95074 },
    { lat: 57.81317, lon: -3.95321 },
    { lat: 57.81387, lon: -3.9539 },
    { lat: 57.81446, lon: -3.95333 },
    { lat: 57.81474, lon: -3.95158 },
    { lat: 57.81439, lon: -3.94939 },
    { lat: 57.81488, lon: -3.94858 },
    { lat: 57.81365, lon: -3.94744 },
    { lat: 57.81493, lon: -3.94229 },
    { lat: 57.8157, lon: -3.94231 },
    { lat: 57.81517, lon: -3.94422 },
    { lat: 57.81594, lon: -3.94424 },
    { lat: 57.81595, lon: -3.94328 },
    { lat: 57.81773, lon: -3.94405 },
    { lat: 57.8189, lon: -3.94288 },
    { lat: 57.82073, lon: -3.93717 },
    { lat: 57.82053, lon: -3.92948 },
    { lat: 57.82093, lon: -3.92693 },
    { lat: 57.82151, lon: -3.92583 },
    { lat: 57.82306, lon: -3.9246 },
    { lat: 57.8265, lon: -3.9186 },
    { lat: 57.82732, lon: -3.91094 },
    { lat: 57.8281, lon: -3.90952 },
    { lat: 57.82944, lon: -3.91138 },
    { lat: 57.82961, lon: -3.91086 },
    { lat: 57.82861, lon: -3.9095 },
    { lat: 57.82717, lon: -3.9021 },
    { lat: 57.82378, lon: -3.89405 },
    { lat: 57.82373, lon: -3.89221 },
    { lat: 57.82453, lon: -3.89186 },
    { lat: 57.82588, lon: -3.89244 },
    { lat: 57.82872, lon: -3.89693 },
    { lat: 57.83838, lon: -3.92047 },
    { lat: 57.83824, lon: -3.9218 },
    { lat: 57.83756, lon: -3.92152 },
    { lat: 57.8369, lon: -3.9222 },
    { lat: 57.83428, lon: -3.91568 },
    { lat: 57.83307, lon: -3.91083 },
    { lat: 57.8315, lon: -3.90897 },
    { lat: 57.83096, lon: -3.90899 },
    { lat: 57.82969, lon: -3.91156 },
    { lat: 57.83099, lon: -3.91639 },
    { lat: 57.83237, lon: -3.91879 },
    { lat: 57.83261, lon: -3.92553 },
    { lat: 57.83345, lon: -3.92785 },
    { lat: 57.83409, lon: -3.92487 },
    { lat: 57.83487, lon: -3.9248 },
    { lat: 57.83527, lon: -3.92579 },
    { lat: 57.83502, lon: -3.9265 },
    { lat: 57.83502, lon: -3.92554 },
    { lat: 57.83374, lon: -3.92646 },
    { lat: 57.83372, lon: -3.92934 },
    { lat: 57.83423, lon: -3.92936 },
    { lat: 57.83472, lon: -3.93177 },
    { lat: 57.83626, lon: -3.93157 },
    { lat: 57.83702, lon: -3.93207 },
    { lat: 57.83955, lon: -3.93694 },
    { lat: 57.84108, lon: -3.93817 },
    { lat: 57.84182, lon: -3.94107 },
    { lat: 57.84465, lon: -3.94466 },
    { lat: 57.84537, lon: -3.94881 },
    { lat: 57.84661, lon: -3.95176 },
    { lat: 57.84702, lon: -3.9519 },
    { lat: 57.84735, lon: -3.95352 },
    { lat: 57.84766, lon: -3.95925 },
    { lat: 57.84615, lon: -3.9682 },
    { lat: 57.84563, lon: -3.96856 },
    { lat: 57.84521, lon: -3.96815 },
    { lat: 57.84418, lon: -3.97073 },
    { lat: 57.84371, lon: -3.9708 },
    { lat: 57.84375, lon: -3.97044 },
    { lat: 57.84345, lon: -3.97089 },
    { lat: 57.84358, lon: -3.97168 },
    { lat: 57.84295, lon: -3.97217 },
    { lat: 57.8397, lon: -3.97963 },
    { lat: 57.82908, lon: -4.00782 },
    { lat: 57.82108, lon: -4.02567 },
    { lat: 57.82065, lon: -4.02852 },
    { lat: 57.81547, lon: -4.04622 },
    { lat: 57.81537, lon: -4.04748 },
    { lat: 57.81587, lon: -4.04745 },
    { lat: 57.8152, lon: -4.04757 },
    { lat: 57.8151, lon: -4.0458 },
    { lat: 57.81476, lon: -4.04593 },
    { lat: 57.81475, lon: -4.04748 },
    { lat: 57.81544, lon: -4.05024 },
    { lat: 57.8181, lon: -4.05551 },
    { lat: 57.81828, lon: -4.05794 },
    { lat: 57.81924, lon: -4.0608 },
    { lat: 57.82266, lon: -4.06557 },
    { lat: 57.8282, lon: -4.0769 },
    { lat: 57.83047, lon: -4.08552 },
    { lat: 57.83212, lon: -4.09836 },
    { lat: 57.83354, lon: -4.10206 },
    { lat: 57.83452, lon: -4.10265 },
    { lat: 57.83664, lon: -4.09818 },
    { lat: 57.83699, lon: -4.09774 },
    { lat: 57.83746, lon: -4.09822 },
    { lat: 57.83669, lon: -4.10363 },
    { lat: 57.83516, lon: -4.10909 },
    { lat: 57.84105, lon: -4.10998 },
    { lat: 57.84084, lon: -4.11111 },
    { lat: 57.83476, lon: -4.10985 },
    { lat: 57.83416, lon: -4.11271 },
    { lat: 57.83794, lon: -4.12337 },
    { lat: 57.84251, lon: -4.13261 },
    { lat: 57.84325, lon: -4.13548 },
    { lat: 57.84479, lon: -4.13713 },
    { lat: 57.84467, lon: -4.13749 },
    { lat: 57.84492, lon: -4.13712 },
    { lat: 57.84392, lon: -4.13926 },
    { lat: 57.84279, lon: -4.13894 },
    { lat: 57.84286, lon: -4.138 },
    { lat: 57.83939, lon: -4.13226 },
    { lat: 57.83753, lon: -4.1312 },
    { lat: 57.83742, lon: -4.12674 },
    { lat: 57.83431, lon: -4.12291 },
    { lat: 57.83403, lon: -4.12201 },
    { lat: 57.83441, lon: -4.12084 },
    { lat: 57.83342, lon: -4.11877 },
    { lat: 57.83261, lon: -4.11784 },
    { lat: 57.83226, lon: -4.11829 },
    { lat: 57.83186, lon: -4.11791 },
    { lat: 57.83121, lon: -4.11811 },
    { lat: 57.83089, lon: -4.11756 },
    { lat: 57.83006, lon: -4.11776 },
    { lat: 57.82923, lon: -4.11986 },
    { lat: 57.82818, lon: -4.13016 },
    { lat: 57.82854, lon: -4.13123 },
    { lat: 57.82817, lon: -4.14091 },
    { lat: 57.83012, lon: -4.14721 },
    { lat: 57.83057, lon: -4.14619 },
    { lat: 57.83141, lon: -4.14799 },
    { lat: 57.83218, lon: -4.14818 },
    { lat: 57.83246, lon: -4.14899 },
    { lat: 57.83299, lon: -4.14863 },
    { lat: 57.83363, lon: -4.1499 },
    { lat: 57.8333, lon: -4.15625 },
    { lat: 57.83379, lon: -4.1633 },
    { lat: 57.83434, lon: -4.16431 },
    { lat: 57.83815, lon: -4.16683 },
    { lat: 57.84403, lon: -4.16847 },
    { lat: 57.84708, lon: -4.17048 },
    { lat: 57.84995, lon: -4.17661 },
  ],
  [
    { lat: 57.84624, lon: -3.93578 },
    { lat: 57.84552, lon: -3.9341 },
    { lat: 57.84465, lon: -3.93378 },
    { lat: 57.8439, lon: -3.93167 },
    { lat: 57.84391, lon: -3.93009 },
    { lat: 57.84238, lon: -3.9281 },
    { lat: 57.84202, lon: -3.9268 },
    { lat: 57.8406, lon: -3.9249 },
    { lat: 57.83996, lon: -3.92501 },
    { lat: 57.83965, lon: -3.92457 },
    { lat: 57.83962, lon: -3.9234 },
    { lat: 57.84058, lon: -3.92265 },
    { lat: 57.84172, lon: -3.92358 },
    { lat: 57.84888, lon: -3.93655 },
    { lat: 57.8498, lon: -3.93915 },
  ],
  [
    { lat: 57.66877, lon: -3.09666 },
    { lat: 57.66846, lon: -3.09753 },
    { lat: 57.66706, lon: -3.09837 },
    { lat: 57.66558, lon: -3.09646 },
    { lat: 57.66455, lon: -3.09593 },
    { lat: 57.66356, lon: -3.09613 },
    { lat: 57.66594, lon: -3.09489 },
    { lat: 57.66651, lon: -3.09411 },
    { lat: 57.66886, lon: -3.09588 },
    { lat: 57.66805, lon: -3.0967 },
    { lat: 57.66877, lon: -3.09666 },
  ],
];

/** Combined coastline for AreaData.coastline. Index 0 is the mainland;
 *  the rest are closed island polygons. */
export const MORAY_FIRTH_COASTLINE: ReadonlyArray<ReadonlyArray<LatLon>> = [
  MORAY_FIRTH_MAINLAND,
  ...MORAY_FIRTH_ISLANDS,
];
